import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
// import { Http, Response, Headers, RequestOptions } from '@angular/http';
// import 'rxjs/add/operator/map';
import { Observable } from 'rxjs';

import { catchError, map,first, tap } from 'rxjs/operators';
import { NetsolinApp } from '../../shared/global';
import { environment } from '../../../environments/environment';
import { AuthService } from './firebase/auth.service';
import { GlobalService } from './global.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { StorageService } from './storage/storage.service';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';

@Injectable({
	providedIn: 'root'
})
export class NetsolinService {
	public modulos: any; //Modulos cargados de NETSOLIN
  public cargo_ruta = false;
	public error_cargarruta = false;
	public men_errorcargarruta = "";
	public cargoidperiodo = false;
	public id_periodo: string = "";
	public id_ruta: number = 0;

  inicializo_netsolin = false;
  documentos:any = [];
	docsoporte:any = [];
	docsoporteaj:any = [];
	anosini:any = [];
	cen_costos:any = [];
  empleados:any =[];
  modelos_dist =[];
	centros:any = [];
	subcentros:any = [];
	acumuladorestodos:any = [];
	acumuladores:any = [];
	coddinam:any = [];
  referprove:any = [];
  todasreferprove:any = [];
	public cargobasenetsolin = false;
	errorcargando = false;
	errorcargandoxsesion = false;
	menerror ='' ;
	nom_empresa = '';
	nit_empresa = '';
	cuserid = '';
	fecha_proceso = new Date();
	loaded = false;
  //op mayop 18 22 crea variables para saber si se ha cargado o no
  cargo_paises = false;
	paisestodos:any = [];
  cargo_responfis = false;
	responfistodos:any = [];
  cargo_ciudades = false;
  cargo_emple =false;
  cargo_modeldis = false;
	ciudadestodas:any = [];
  cargo_activeco = false;
	activecotodas:any = [];
  cargo_tbasecrm = false;
  sectorescrm :any = [];
  cargo_campanascrm = false;
  campanascrm :any = [];
  cargoscrm :any = [];
  origcliepotcrm :any = [];
  cargo_tbasedocven = false;
  cargo_tbasedocsopor = false;
	aproc_ven:any = [];
  aprocvencotiz:any =[];
  amonedas :any = [];
  afor_pago :any = [];
  ac_lis_prec :any = [];
  avendedores :any = [];
  azonas :any = [];
  acausal_perd :any = [];
  acompetencia :any = [];
  cargo_oricliepot = false;
  cargo_cliepot = false;
  cliepotencial :any = [];
  cargo_terce = false;
  terceros :any = [];
  cargo_contactos = false;
  contactos :any = [];
  cargo_claxvolven = false;
  claxvolven :any = [];
  cargo_forpago = false;
  forpago :any = [];
  for_pago:any = [];
  cargo_vendedores = false;
  vendedores :any = [];
  cargo_zonas = false;
  zonas :any = [];
  cargo_listaprecios = false;
  listaprecios :any = [];
  cargo_procven = false;
  aprocven:any = [];
  cargo_tipoclientes = false;
  tipoclientes :any = [];
  cargo_tipoproveedores = false;
  tipoproveedores :any = [];
//VARIABLES PUBLICAS PARA SABER SI HA INICIALIADO COMPONENETES Y NO VOLVER A CARGAR DDT NI SEG OBJETOS
  inicializo_actividades = false;
  inicializo_archivos = false;
  inicializo_cotiza = false;
  inicializo_cotizaprod = false;
  ult_tokenfb='';
  urlwebnetsolin='';
  cargo_cc = false;
  cargo_acum = false;
  cargo_coddinam = false;
  cargo_anosini = false;
  cargo_formpago = false;
  cargo_monedas = false;
  cargo_dsopa = false;
  cargo_dsop = false;

  public formageneradcosopor: Array<{ text: string; value: number }> = [
    { text: "Por Operación", value: 1 },
    { text: "Acumulado Semanal", value: 2 },
  ];

  constructor(private http: HttpClient, private oauth: AuthService,
    private globalfb: GlobalService,
    private svstorage: StorageService) {
	}
  async inicializarNetsolin(OappService:any){
		// console.log('inicializarNetsolin', OappService);
		//inicializamos objetos que llaman netsolin con url definido en oapp.service firebase
		this.cuserid = OappService.usuarionetsolin;
		NetsolinApp.urlNetsolin = OappService.urlservirestnetsolin;
    this.urlwebnetsolin =   OappService.urlwebnetsolin;
    NetsolinApp.urlwebnetsolin = OappService.urlwebnetsolin;
		NetsolinApp.oapp.cuserid = OappService.usuarionetsolin;
		NetsolinApp.oapp.cuserpsw = OappService.tokennetsolin;
		NetsolinApp.objenvrest.usuario = OappService.usuarionetsolin;
		NetsolinApp.objenvrest.psw = OappService.tokennetsolin;
		NetsolinApp.objenvrest.prefijobd = OappService.prefijoemprenetsolin;
		NetsolinApp.objenvrestcrud.usuario = OappService.usuarionetsolin;
		NetsolinApp.objenvrestcrud.psw = OappService.tokennetsolin;
		NetsolinApp.objenvrestcrud.prefijobd = OappService.prefijoemprenetsolin;
		NetsolinApp.objenvrestddtabla.usuario = OappService.usuarionetsolin;
		NetsolinApp.objenvrestddtabla.psw = OappService.tokennetsolin;
		NetsolinApp.objenvrestddtabla.prefijobd = OappService.prefijoemprenetsolin;
		NetsolinApp.objenvrestsolcomobog.usuario = OappService.usuarionetsolin;
		NetsolinApp.objenvrestsolcomobog.psw = OappService.tokennetsolin;
		NetsolinApp.objenvrestsolcomobog.prefijobd = OappService.prefijoemprenetsolin;

		localStorage.setItem('urlNetsolin', NetsolinApp.urlNetsolin);
		await this.actParamNetsolin(OappService.prefijoemprenetsolin);
		// console.log('realizo loadhtmlNetsolinbase NetsolinApp: ', NetsolinApp);

	}

registrarUsuarioNetsolin(usuario, cargoEmpresa, empresa?){

	if(cargoEmpresa){
		NetsolinApp.objenvrest.prefijobd = empresa.parNetsolin.prefijoemprenetsolin;
		NetsolinApp.urlNetsolin = empresa.parNetsolin.urlservirestnetsolin;;
	}else{
		var netsolin_ini = JSON.parse(localStorage.getItem('netsolin_ini'));
		NetsolinApp.objenvrest.prefijobd =netsolin_ini.prefijobd;
		NetsolinApp.urlNetsolin = localStorage.getItem("urlNetsolin") || '{}';
	}
    NetsolinApp.objenvrest.usuario = "NETSDESAA";
    NetsolinApp.objenvrest.psw =  "Xxcx23232ASAS2323ZDsdc855";
	NetsolinApp.objenvrest.en_prod = "NOPROD"
    NetsolinApp.objenvrest.parametros = usuario;
	return new Promise((resolve, reject) => {
		this.http.post(NetsolinApp.urlNetsolin + "Ejeservi_rest.csvc?VRCod_obj=ANGCREAUSUARIO",NetsolinApp.objenvrest).subscribe((result: any) => {
    // this.http.post(NetsolinApp.urlNetsolin + "Ejeservi_rest_sinsession.csvc?VRCod_obj=ANGCREAUSUARIO",NetsolinApp.objenvrest).subscribe((result: any) => {
        // console.log('Registro de usuario -> ', result);
			resolve(result);
		});
	});
}


consultarUsuarioNetsolin(usuario, cargoEmpresa, empresa?){
	if(cargoEmpresa){
		NetsolinApp.objenvrest.prefijobd = empresa.parNetsolin.prefijoemprenetsolin;
		NetsolinApp.urlNetsolin = empresa.parNetsolin.urlservirestnetsolin;;
	}else{
		var netsolin_ini = JSON.parse(localStorage.getItem('netsolin_ini'));
		NetsolinApp.objenvrest.prefijobd =netsolin_ini.prefijobd;
		NetsolinApp.urlNetsolin = localStorage.getItem("urlNetsolin") || '{}';
		NetsolinApp.objenvrest.prefijobd =netsolin_ini.prefijobd;
	}
    NetsolinApp.objenvrest.usuario = "NETSDESAA";
    NetsolinApp.objenvrest.psw =  "Xxcx23232ASAS2323ZDsdc855";
	NetsolinApp.objenvrest.en_prod = "NOPROD"
    NetsolinApp.objenvrest.parametros = usuario;
	return new Promise((resolve, reject) => {
		this.http.post(NetsolinApp.urlNetsolin + "Ejeservi_rest.csvc?VRCod_obj=ANGCREAUSUARIO",NetsolinApp.objenvrest).subscribe((result: any) => {
  //  this.http.post(NetsolinApp.urlNetsolin + "Ejeservi_rest_sinsession.csvc?VRCod_obj=ANGCREAUSUARIO",NetsolinApp.objenvrest).subscribe((result: any) => {
        // console.log('Consulta de usuario -> ', result);
			resolve(result);
		});
	});
}

//OP mayo 20 22 CARGA tbase doc ventas PROC_VEN, C_LIS_PREC,MONEDAS,VENDEDORES,FOR_PAGO,ZONAS,CAUSAL_PERD,COMPETENCIA
cargaTbasedocventasNetsolin(){
  this.cargo_tbasedocven = false;
  // console.log('cargando tbase crm netsolin');
  this.getNetsolinObjconParametrosretobj('CARGATBASDOCVEN',NetsolinApp.objenvrestsolcomobog).then(sub=> sub
  .subscribe((result:any) => {
      //viene registro con datos de la grafica
      // console.log("handleOpcionChange eje getNetsolinObjconParametrosretobj retorna result");
      // console.log(result);
      this.aproc_ven=result.proc_ven;
      //filtra solo los que tienen cotizaciones para llamado en cotizaciones
      this.aprocvencotiz = this.aproc_ven.filter((s:any) => s.util_cotiz && !s.inactivo);
      // console.log('this.aproc_ven, this.aprocvencotiz',this.aproc_ven, this.aprocvencotiz);
      this.amonedas=result.monedas;
      this.afor_pago=result.for_pago;
      this.ac_lis_prec=result.c_lis_prec;
      this.avendedores=result.vendedores;
      this.azonas=result.zonas;
      this.acausal_perd=result.causal_perd;
      this.acompetencia=result.competencia;
      this.cargo_tbasedocven=true;
      // console.log(result0);
      if (typeof result.isCallbackError === "undefined") {
        //viene el registro con datos para el grafico
        console.log("handleOpcionChange eje getNetsolinObjconParametrosretobj retorna con datos grafico result");
        console.error(result);
      } else {
        //viene el registro con el error
        console.log("Error en getNetsolinObjconParametrosretobj result");
        console.error(result);
      }
    },
    (error:any) => {
      console.log("Error en getNetsolinObjconParametros error otro tipo");
      console.error(error);
    }
  ));
}
//OP mayo 19 22 CARGA tbase crm sectorcrm,campanas,origclipot
cargaTbasecrmNetsolin(){
  this.cargo_tbasecrm = false;
  // console.log('cargando tbase crm netsolin');
  this.getNetsolinObjconParametrosretobj('CARGATBASCRM',NetsolinApp.objenvrestsolcomobog).then(sub=> sub
  .subscribe((result:any) => {
      //viene registro con datos de la grafica
      // console.log("handleOpcionChange eje getNetsoli0nObjconParametrosretobj retorna result");
      // console.log(result);
      this.sectorescrm=result.sectorcrm;
      this.campanascrm=result.campanas;
      this.cargoscrm = result.cargoscrm;
      this.origcliepotcrm=result.origclipot;
      this.cargo_tbasecrm=true;
      // console.log(result0);
      if (typeof result.isCallbackError === "undefined") {
        //viene el registro con datos para el grafico
        console.log("handleOpcionChange eje getNetsolinObjconParametrosretobj retorna con datos grafico result");
        console.log(result);
      } else {
        //viene el registro con el error
        console.log("Error en getNetsolinObjconParametrosretobj result");
        console.error(result);
      }
    },
    (error:any) => {
      console.log("Error en getNetsolinObjconParametros error otro tipo");
      console.error(error);
    }
  ));
}

//OP Julio 15 22 Carga responsabilidades fiscales
cargaResponfiscalNetsolin(){
  let filtro ='*';
  this.cargo_responfis = false;
  // console.log('cargando responfis netsolin');
  var objllama = { ...NetsolinApp.objenvrestsolcomobog};
      objllama.tabla = "respons";
      objllama.orden = 'cod_res';
      objllama.aplica = 0;
      objllama.filtroadi = filtro;
      objllama.filtro = filtro;
      objllama.campollave = 'cod_res';
      objllama.campos = "cod_res,cod_res as id,des_res,des_res as text";
      objllama.llave = '';
      objllama.cursor = "Tcursorx";
  // objllama.en_prod ='NOPROD';
  // console.log('cargando responfis netsolin llamado con ',objllama);
  // this.cargobasenetsolin=true;
  this.getNetsolinresponfiscal(objllama).then(sub=> sub
    .subscribe((result: any) => {
      // console.log('resul responfis ',result);
      if (result.isCallbackError){
        console.log('Error al traer responfis',result.messages)
      } else {
        this.responfistodos = result;
        this.cargo_responfis = true;
        // console.log('this.responfistodos:',this.responfistodos);
      }
   }));
}
async getNetsolinresponfiscal(pobjllama:any): Promise<Observable<any>> {
  pobjllama.usuario = this.globalfb.user.id;
  pobjllama.psw = NetsolinApp.oapp.cuserpsw;
  pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
  pobjllama.tokenfb = await this.oauth.getAuthToken();
  this.ult_tokenfb = pobjllama.tokenfb;
return this.http.post(NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc", pobjllama)
  .pipe(
  map(resul => {
    return resul;
  })
  );
}
//OP mayo 18 22 CARGA paises
cargaPaisesNetsolin(){
  let filtro ='*';
  this.cargo_paises = false;
  // console.log('cargando paises netsolin');
  var objllama = { ...NetsolinApp.objenvrestsolcomobog};
      objllama.tabla = "paises";
      objllama.orden = 'cod_pais';
      objllama.aplica = 0;
      objllama.filtroadi = filtro;
      objllama.filtro = filtro;
      objllama.campollave = 'cod_pais';
      objllama.campos = "cod_pais,cod_pais as id,nombre,nombre as text";
      objllama.llave = '';
      objllama.cursor = "Tcursorx";
  // objllama.en_prod ='NOPROD';
  // console.log('cargando paises netsolin llamado con ',objllama);
  // this.cargobasenetsolin=true;
  this.getNetsolinpaises(objllama).then(sub=> sub
    .subscribe((result: any) => {
      // console.log('resul paises ',result);
      if (result.isCallbackError){
        console.log('Error al traer paises',result.messages)
      } else {
        this.paisestodos = result;
        this.cargo_paises = true;
        // console.log('this.paisestodos:',this.paisestodos);
      }
   }));
}
async getNetsolinpaises(pobjllama:any): Promise<Observable<any>> {
  pobjllama.usuario = this.globalfb.user.id;
  pobjllama.psw = NetsolinApp.oapp.cuserpsw;
  pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
  pobjllama.tokenfb = await this.oauth.getAuthToken();
  this.ult_tokenfb = pobjllama.tokenfb;
return this.http.post(NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc", pobjllama)
  .pipe(
  map(resul => {
    return resul;
  })
  );
}

//OP mayo 18 22 CARGA ciudades
cargaCiudadesNetsolin(){
  let filtro ='*';
  this.cargo_ciudades = false;
  // console.log('cargando ciudades netsolin');
  var objllama = { ...NetsolinApp.objenvrestsolcomobog};
      objllama.tabla = "ciudades";
      objllama.orden = 'cod_ciudad';
      objllama.aplica = 0;
      objllama.filtroadi = filtro;
      objllama.filtro = filtro;
      objllama.campollave = 'cod_ciudad';
      objllama.campos = "cod_ciudad,cod_ciudad as id,nombre,nombre as text";
      objllama.llave = '';
      objllama.cursor = "Tcursorx";
  objllama.en_prod ='NOPROD';
  // console.log('cargando ciudades netsolin llamado con ',objllama);
  // this.cargobasenetsolin=true;
  this.getNetsolinciudades(objllama).then(sub=> sub
    .subscribe((result: any) => {
      // console.log('resul ciudades ',result);
      if (result.isCallbackError){
        console.log('Error al traer ciudades',result.messages)
      } else {
        this.ciudadestodas = result;
        this.cargo_ciudades = true;
        // console.log('this.ciudadestodas:',this.ciudadestodas);
      }
   }));
}
async getNetsolinciudades(pobjllama:any): Promise<Observable<any>> {
    pobjllama.usuario = this.globalfb.user.id;
    pobjllama.psw = NetsolinApp.oapp.cuserpsw;
    pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
    pobjllama.tokenfb = await this.oauth.getAuthToken();
    this.ult_tokenfb = pobjllama.tokenfb;
    return this.http.post(NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc", pobjllama)
  .pipe(
  map(resul => {
    return resul;
  })
  );
}
//OP mayo 18 22 CARGA actividades economicas
cargaActiviecoNetsolin(){
  let filtro ='*';
  this.cargo_activeco = false;
  // console.log('cargando activ eco netsolin');
  var objllama = { ...NetsolinApp.objenvrestsolcomobog};
      objllama.tabla = "ACT_INDC";
      objllama.orden = 'cod_acteic';
      objllama.aplica = 0;
      objllama.filtroadi = filtro;
      objllama.filtro = filtro;
      objllama.campollave = 'cod_acteic';
      objllama.campos = "cod_acteic,cod_acteic as id,nombre,nombre as text";
      objllama.llave = '';
      objllama.cursor = "Tcursorx";
  objllama.en_prod ='NOPROD';
  // console.log('cargando activ eco netsolin llamado con ',objllama);
  // this.cargobasenetsolin=true;
  this.getNetsolinvexireftabla(objllama).then(sub=> sub
    .subscribe((result: any) => {
      // console.log('resul activ eco ',result);
      if (result.isCallbackError){
        console.log('Error al traer activ eco',result.messages)
      } else {
        this.activecotodas = result;
        this.cargo_activeco = true;
        // console.log('this.activecotodas:',this.activecotodas);
      }
   }));
}
async getNetsolinvexireftabla(pobjllama:any): Promise<Observable<any>> {
    pobjllama.usuario = this.globalfb.user.id;
    pobjllama.psw = NetsolinApp.oapp.cuserpsw;
    pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
    pobjllama.tokenfb = await this.oauth.getAuthToken();
    this.ult_tokenfb = pobjllama.tokenfb;
return this.http.post(NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc", pobjllama)
  .pipe(
  map(resul => {
    return resul;
  })
  );
}


//OP mayo 20 22 CARGA clientes potenciales
cargaCliePoteNetsolin(){
	let filtro ="id_cuenta =  0 AND estado != '2' ";
	this.cargo_cliepot = false;
	// console.log('cargando activ eco netsolin');
	var objllama = { ...NetsolinApp.objenvrestsolcomobog};
		objllama.tabla = "CLIENPOTEN";
		objllama.orden = 'id_cliepote';
		objllama.aplica = 21;
		objllama.filtroadi = filtro;
		objllama.filtro = filtro;
		objllama.campollave = 'id_cliepote';
		objllama.campos = "id_cliepote,id_cliepote as id,nom_empre,nom_empre as text";
		objllama.llave = '';
		objllama.cursor = "Tcursorx";
	objllama.en_prod ='NOPROD';
	// console.log('cargando cliente potencial netsolin llamado con ',objllama);
	// this.cargobasenetsolin=true;
	this.getNetsolinvexireftabla(objllama).then(sub=> sub
	  .subscribe((result: any) => {
		// console.log('resul cliepote eco ',result);
		if (result.isCallbackError){
		  console.log('Error al traer cliepote',result.messages)
		} else {
		  this.cliepotencial = result;
		  this.cargo_cliepot = true;
		  // console.log('this.cliepote:',this.cliepotencial);
		}
	 }));
  }

  cargaTercerosNetsolin(){
	let filtro ='*';
	this.cargo_terce = false;
	// console.log('cargando activ eco netsolin');
	var objllama = { ...NetsolinApp.objenvrestsolcomobog};
		objllama.tabla = "TERCEROS";
		objllama.orden = 'COD_TERCER';
		objllama.aplica = 21;
		objllama.filtroadi = filtro;
		objllama.filtro = filtro;
		objllama.campollave = 'COD_TERCER';
		objllama.campos = "cod_tercer,cod_tercer as id,nombre,nombre as text";
		objllama.llave = '';
		objllama.cursor = "Tcursorx";
	objllama.en_prod ='NOPROD';
	// console.log('cargando terceros llamado con ',objllama);
	// this.cargobasenetsolin=true;
	this.getNetsolinvexireftabla(objllama).then(sub=> sub
	  .subscribe((result: any) => {
		console.log('resulterceros ',result);
		if (result.isCallbackError){
		  console.log('Error al traer terceros',result.messages)
		} else {
		  this.terceros = result;
		  this.cargo_terce = true;
		  // console.log('this.terceros:',this.terceros);
		}
	 }));
  }

  cargaContactosNetsolin(){
	let filtro ='*';
	this.cargo_contactos = false;
	// console.log('cargando contactos netsolin');
	var objllama = { ...NetsolinApp.objenvrestsolcomobog};
		objllama.tabla = "CONTACTOS";
		objllama.orden = 'ID_CONTACTO';
		objllama.aplica = 21;
		objllama.filtroadi = filtro;
		objllama.filtro = filtro;
		objllama.campollave = 'ID_CONTACTO';
		objllama.campos = "id_contacto,id_contacto as id,nombres, CONCAT(nombres, ' ', apellidos) as text";
		objllama.llave = '';
		objllama.cursor = "Tcursorx";
	objllama.en_prod ='NOPROD';
	// console.log('cargando contactos llamado con ',objllama);
	// this.cargobasenetsolin=true;
	this.getNetsolinvexireftabla(objllama).then(sub=> sub
	  .subscribe((result: any) => {
		// console.log('resulcontactos ',result);
		if (result.isCallbackError){
		  console.log('Error al traer contactos',result.messages)
		} else {
		  this.contactos = result;
		  this.cargo_contactos = true;
		  // console.log('this.contactos:',this.contactos);
		}
	 }));
  }

  cargaClaXVolVenNetsolin(){
	let filtro ='*';
	this.cargo_claxvolven = false;
	// console.log('cargando ClaXvolVen netsolin');
	var objllama = { ...NetsolinApp.objenvrestsolcomobog};
		objllama.tabla = "CLA_XVOLVEN";
		objllama.orden = 'ID_VENTAS';
		objllama.aplica = 0;
		objllama.filtroadi = filtro;
		objllama.filtro = filtro;
		objllama.campollave = 'ID_VENTAS';
		objllama.campos = "id_ventas,id_ventas as id,nombre, nombre as text";
		objllama.llave = '';
		objllama.cursor = "Tcursorx";
	objllama.en_prod ='NOPROD';
	// console.log('cargando ClaXvolVen llamado con ',objllama);
	// this.cargobasenetsolin=true;
	this.getNetsolinvexireftabla(objllama).then(sub=> sub
	  .subscribe((result: any) => {
		// console.log('resul ClaXvolVen ',result);
		if (result.isCallbackError){
		  console.log('Error al traer ClaXvolVen',result.messages)
		} else {
		  this.claxvolven = result;
		  this.cargo_claxvolven = true;
		  // console.log('this.claxvolven:',this.cargo_claxvolven);
		}
	 }));
  }


  cargaForPagoNetsolin(){
	let filtro ='*';
	this.cargo_forpago = false;
	// console.log('cargando forpago netsolin');
	var objllama = { ...NetsolinApp.objenvrestsolcomobog};
		objllama.tabla = "FOR_PAGO";
		objllama.orden = 'COD_FPAGO';
		objllama.aplica = 0;
		objllama.filtroadi = filtro;
		objllama.filtro = filtro;
		objllama.campollave = 'COD_FPAGO';
		objllama.campos = "cod_fpago,cod_fpago as id,nombre, nombre as text, num_cuotas, tmp_cuotas";
		objllama.llave = '';
		objllama.cursor = "Tcursorx";
	objllama.en_prod ='NOPROD';
	// console.log('cargando forpago llamado con ',objllama);
	// this.cargobasenetsolin=true;
	this.getNetsolinvexireftabla(objllama).then(sub=> sub
	  .subscribe((result: any) => {
		// console.log('resul forpago ',result);
		if (result.isCallbackError){
		  console.log('Error al traer forpago',result.messages)
		} else {
		  this.forpago = result;
		  this.cargo_forpago = true;
		  // console.log('this.forpago:',this.forpago);
		}
	 }));
  }

  cargaVendedoresNetsolin(){
	let filtro ='*';
	this.cargo_vendedores = false;
	// console.log('cargando Vendedores netsolin');
	var objllama = { ...NetsolinApp.objenvrestsolcomobog};
		objllama.tabla = "VENDEDORES";
		objllama.orden = 'COD_VENDED';
		objllama.aplica = 0;
		objllama.filtroadi = filtro;
		objllama.filtro = filtro;
		objllama.campollave = 'COD_VENDED';
		objllama.campos = "cod_vended,cod_vended as id,detalle, detalle as text";
		objllama.llave = '';
		objllama.cursor = "Tcursorx";
	objllama.en_prod ='NOPROD';
	// console.log('cargando Vendedores llamado con ',objllama);
	// this.cargobasenetsolin=true;
	this.getNetsolinvexireftabla(objllama).then(sub=> sub
	  .subscribe((result: any) => {
		// console.log('resul Vendedores ',result);
		if (result.isCallbackError){
		  console.log('Error al traer Vendedores',result.messages)
		} else {
		  this.vendedores = result;
		  this.cargo_vendedores = true;
		  // console.log('this.Vendedores:',this.vendedores);
		}
	 }));
  }


  cargaZonasNetsolin(){
	let filtro ='*';
	this.cargo_zonas = false;
	// console.log('cargando Zonas netsolin');
	var objllama = { ...NetsolinApp.objenvrestsolcomobog};
		objllama.tabla = "ZONAS";
		objllama.orden = 'COD_ZONA';
		objllama.aplica = 0;
		objllama.filtroadi = filtro;
		objllama.filtro = filtro;
		objllama.campollave = 'COD_ZONA';
		objllama.campos = "cod_zona,cod_zona as id,nombre, nombre as text";
		objllama.llave = '';
		objllama.cursor = "Tcursorx";
	objllama.en_prod ='NOPROD';
	// console.log('cargando Zonas llamado con ',objllama);
	// this.cargobasenetsolin=true;
	this.getNetsolinvexireftabla(objllama).then(sub=> sub
	  .subscribe((result: any) => {
		// console.log('resul Zonas ',result);
		if (result.isCallbackError){
		  console.log('Error al traer Zonas',result.messages)
		} else {
		  this.zonas = result;
		  this.cargo_zonas = true;
		  // console.log('this.Zonas:',this.zonas);
		}
	 }));
  }

  cargaListaPreciosNetsolin(){
	let filtro ='*';
	this.cargo_listaprecios = false;
	// console.log('cargando ListaPrecios netsolin');
	var objllama = { ...NetsolinApp.objenvrestsolcomobog};
		objllama.tabla = "C_LIS_PREC";
		objllama.orden = 'COD_LISTA';
		objllama.aplica = 0;
		objllama.filtroadi = filtro;
		objllama.filtro = filtro;
		objllama.campollave = 'COD_LISTA';
		objllama.campos = "cod_lista,cod_lista as id,nombre, nombre as text";
		objllama.llave = '';
		objllama.cursor = "Tcursorx";
	objllama.en_prod ='NOPROD';
	// console.log('cargando ListaPrecios llamado con ',objllama);
	// this.cargobasenetsolin=true;
	this.getNetsolinvexireftabla(objllama).then(sub=> sub
	  .subscribe((result: any) => {
		// console.log('resul ListaPrecios ',result);
		if (result.isCallbackError){
		  console.log('Error al traer ListaPrecios',result.messages)
		} else {
		  this.listaprecios = result;
		  this.cargo_listaprecios = true;
		  // console.log('this.ListaPrecios:',this.listaprecios);
		}
	 }));
  }

  cargaTipoClientesNetsolin(){
	let filtro ='*';
	this.cargo_tipoclientes = false;
	// console.log('cargando TipoClientes netsolin');
	var objllama = { ...NetsolinApp.objenvrestsolcomobog};
		objllama.tabla = "TIPO_CLIEN";
		objllama.orden = 'COD_TIPO';
		objllama.aplica = 0;
		objllama.filtroadi = filtro;
		objllama.filtro = filtro;
		objllama.campollave = 'COD_TIPO';
		objllama.campos = "cod_tipo,cod_tipo as id,nombre, nombre as text";
		objllama.llave = '';
		objllama.cursor = "Tcursorx";
	objllama.en_prod ='NOPROD';
	// console.log('cargando TipoClientes llamado con ',objllama);
	// this.cargobasenetsolin=true;
	this.getNetsolinvexireftabla(objllama).then(sub=> sub
	  .subscribe((result: any) => {
		// console.log('resul TipoClientes ',result);
		if (result.isCallbackError){
		  console.log('Error al traer TipoClientes',result.messages)
		} else {
		  this.tipoclientes = result;
		  this.cargo_tipoclientes = true;
		  // console.log('this.TipoClientes:',this.tipoclientes);
		}
	 }));
  }

  cargaTipoProveedoresNetsolin(){
	let filtro ='*';
	this.cargo_tipoproveedores = false;
	// console.log('cargando TipoProveedoes netsolin');
	var objllama = { ...NetsolinApp.objenvrestsolcomobog};
		objllama.tabla = "TIPO_PRO";
		objllama.orden = 'COD_TIPO';
		objllama.aplica = 0;
		objllama.filtroadi = filtro;
		objllama.filtro = filtro;
		objllama.campollave = 'COD_TIPO';
		objllama.campos = "cod_tipo,cod_tipo as id,nombre, nombre as text";
		objllama.llave = '';
		objllama.cursor = "Tcursorx";
	objllama.en_prod ='NOPROD';
	// console.log('cargando TipoProveedoes llamado con ',objllama);
	// this.cargobasenetsolin=true;
	this.getNetsolinvexireftabla(objllama).then(sub=> sub
	  .subscribe((result: any) => {
		// console.log('resul TipoProveedoes ',result);
		if (result.isCallbackError){
		  console.log('Error al traer TipoProveedoes',result.messages)
		} else {
		  this.tipoproveedores = result;
		  this.cargo_tipoproveedores = true;
		  // console.log('this.TipoProveedoes:',this.tipoproveedores);
		}
	 }));
  }

async	loadhtmlNetsolinbase() {
		// console.log('en loadhtmlNetsolinbase del netsolin.service this.cargobasenetsolin:',this.cargobasenetsolin);
		this.cargobasenetsolin=false;
    //op jul 7 22 se cambia para que funcione con token firebase
		// this.getNetsolinhtmlbase()
	await this.getNetsolinhtmlbasefb()
			.then(async(result:any) => {
				// console.log('getNetsolinhtmlbase result', result);
				if (!result || typeof result.isCallbackError != "undefined") {
					this.errorcargando = true;
					this.errorcargandoxsesion = true;
					// console.log("loadhtmlNetsolinbase Error");
					this.cargobasenetsolin = false;
          console.error('en loadhtmlNetsolinbase del netsolin.service this.cargobasenetsolin:',this.cargobasenetsolin);
          this.inicializo_netsolin = false;
          //this.globalfb.inicializo_netsolin = false;
					this.menerror = !result ? 'No cargo Netsolin base' : result.messages;
          console.error('No se pudo inicializar Netsolin. Verificar usuario.',this.menerror)
					return;
				}
				//  console.log("getNetsolinhtmlbase result");
				//  console.log(result);
				//  console.log('result.oapp');
				//  console.log(result.oapp);
				// result.oapp.cuserid = 'S';
				// result.oapp.cuserpsw = '818B9B5D757885A18D8B908B8D9C989594A397AB9DA0AC9B9DD3CAD0D7C9CCA6CAD7D5D9D8CED6CFAFDFE1E4D4D88DA0A186';
				let var1: any = JSON.stringify(result.oapp);
				// console.log("var 1");
				// console.log(var1);
				localStorage.setItem('OappNetsolin', var1);
				NetsolinApp.objtitmodulo.titulo = 'Netsolin';
				NetsolinApp.iniNetsolin = true;
				NetsolinApp.oapp.cuserid = result.oapp.cuserid;
				NetsolinApp.oapp.cuserpsw = result.oapp.cuserpsw;
				NetsolinApp.oapp.nomusuar = result.oapp.nomusuar;
				NetsolinApp.oapp.superusuar = result.oapp.superusuar;
				NetsolinApp.oapp.nom_empresa = result.oapp.nom_empresa;
        NetsolinApp.oapp.dg_aplica = result.oapp.dg_aplica;
				NetsolinApp.oapp.nit_empresa = result.oapp.nit_empresa;
				NetsolinApp.oapp.prefijo_sqlbd = result.oapp.prefijo_sqlbd;
				NetsolinApp.oapp.num_version = result.oapp.num_version;
				NetsolinApp.oapp.fecha_proceso = result.oapp.fecha_proceso;
        NetsolinApp.oapp.par_pucc = result.oapp.par_pucc;
        NetsolinApp.oapp.par_puscc = result.oapp.par_puscc;
        NetsolinApp.oapp.par_pucd = result.oapp.par_pucd;
        NetsolinApp.oappapl = result.oapp;
        NetsolinApp.oapl_contabil = result.oapl_contabil;
        NetsolinApp.oapl_operativos = result.oapl_operativos;

				// if (environment.production) {
				// 	NetsolinApp.oapp.en_prod = 'ENPROD';
				// 	NetsolinApp.objenvrest.en_prod = 'ENPROD';
				// 	NetsolinApp.objenvrestddtabla.en_prod = 'ENPROD';
				// 	NetsolinApp.objenvrestsolcomobog.en_prod = 'ENPROD';
				// 	NetsolinApp.objenvrestcrud.en_prod = 'ENPROD';
				// } else {
				// 	NetsolinApp.oapp.en_prod = 'NOPROD';
				// 	NetsolinApp.objenvrest.en_prod = 'NOPROD';
				// 	NetsolinApp.objenvrestddtabla.en_prod = 'NOPROD';
				// 	NetsolinApp.objenvrestsolcomobog.en_prod = 'NOPROD';
				// 	NetsolinApp.objenvrestcrud.en_prod = 'NOPROD';
				// }
				NetsolinApp.oapp.motor = result.oapp.motor;
				this.nom_empresa = NetsolinApp.oapp.nom_empresa;
				this.nit_empresa = NetsolinApp.oapp.nit_empresa;
				this.fecha_proceso = NetsolinApp.oapp.fecha_proceso;
				this.cargobasenetsolin = true;
        // console.log('en loadhtmlNetsolinbase del netsolin.service this.cargobasenetsolin:',this.cargobasenetsolin);
        this.inicializo_netsolin = true;
        //this.globalfb.inicializo_netsolin = true;

			}, error => {
				 console.log('error loadhtmlNetsolinbase');
				 console.log(error.message);
				// this.showError(error);
				this.cargobasenetsolin = false;
        console.error('en loadhtmlNetsolinbase del netsolin.service this.cargobasenetsolin:',this.cargobasenetsolin);
				this.menerror = error.message;
				this.errorcargando = true;
				this.errorcargandoxsesion = false;
        this.inicializo_netsolin = false;
        //this.globalfb.inicializo_netsolin = false;
    });

	  }

	  //op feb 25 22 actualiza parametros netsolin
	  async actParamNetsolin(pprefijoemp:any){
		let filtro ='*';
		// console.log('actParamNetsolin netsolin');
		// NetsolinApp.objenvrestddtabla.usuario = NetsolinApp.oapp.cuserid;
        // NetsolinApp.objenvrestddtabla.psw = NetsolinApp.oapp.cuserpsw;
        NetsolinApp.objenvrestddtabla.prefijobd = pprefijoemp;
		NetsolinApp.oapp.prefijo_sqlbd = pprefijoemp;
		// NetsolinApp.objenvrestsolcomobog.en_prod ='NOPROD';
		// NetsolinApp.urlNetsolin = "http://40.85.161.231/CERCANOSREST/";
		// console.log('cactParamNetsolin llamado con ',NetsolinApp);
		// this.cargobasenetsolin=true;
		// this.getNetsolinparam().then(sub=> sub
      this.loadhtmlNetsolinbase().then( (result:any) =>{
        // this.getNetsolinparam().then((result:any)=>{
          // console.log('resul loadhtmlNetsolinbase',result);
          NetsolinApp.oapp.prefijo_sqlbd = pprefijoemp;
          //OJO OP AQUI SE DEBE ASIGNAR EL USUARIO Y PSW QUE VENGA DE FIREBASE
          //POR QUE CUANDO EL WEB SE REINICIA QUEDAN EN BLANC O Y FALLA EL INICIO
          // NetsolinApp.oapp.cuserid = result.oapp.cuserid;
          // NetsolinApp.oapp.cuserpsw = result.oapp.cuserpsw;
          // NetsolinApp.oapp.cuserid = 'NETSDESAA';
          // NetsolinApp.oapp.cuserpsw = 'Xxcx23232ASAS2323ZDsdc855';
          // NetsolinApp.oapp.nit_empresa = result.oapp.nit_empresa;
          // NetsolinApp.oapp.nom_empresa = result.oapp.nom_empresa;
          // NetsolinApp.oapp.par_pucc = result.oapp.par_pucc;
          // NetsolinApp.oapp.par_puscc = result.oapp.par_puscc;
          // NetsolinApp.oapp.par_pucd = result.oapp.par_pucd;
          // NetsolinApp.oappapl = result.oapp;
          // NetsolinApp.oapl_contabil = result.oapl_contabil;
          // console.log('NetsolinApp cambiado',NetsolinApp);
          this.loaded = true;

        // })
      });

			// .subscribe(async (result: any)  => {
			// 	console.log('resul getNetsolinparam',result);
			// 	NetsolinApp.oapp.prefijo_sqlbd = pprefijoemp;
			// 	//OJO OP AQUI SE DEBE ASIGNAR EL USUARIO Y PSW QUE VENGA DE FIREBASE
			// 	//POR QUE CUANDO EL WEB SE REINICIA QUEDAN EN BLANC O Y FALLA EL INICIO
			// 	// NetsolinApp.oapp.cuserid = result.oapp.cuserid;
			// 	// NetsolinApp.oapp.cuserpsw = result.oapp.cuserpsw;
			// 	// NetsolinApp.oapp.cuserid = 'NETSDESAA';
			// 	// NetsolinApp.oapp.cuserpsw = 'Xxcx23232ASAS2323ZDsdc855';
			// 	NetsolinApp.oapp.nit_empresa = result.oapp.nit_empresa;
			// 	NetsolinApp.oapp.nom_empresa = result.oapp.nom_empresa;
			// 	NetsolinApp.oapp.par_pucc = result.oapp.par_pucc;
			// 	NetsolinApp.oapp.par_puscc = result.oapp.par_puscc;
			// 	NetsolinApp.oapp.par_pucd = result.oapp.par_pucd;
			// 	NetsolinApp.oappapl = result.oapp;
			// 	NetsolinApp.oapl_contabil = result.oapl_contabil;
			// 	console.log('NetsolinApp cambiado',NetsolinApp);
			// 	// await this.loadhtmlNetsolinbase();
			// 	 this.getNetsolinparam();
			// 	console.log('Netsolin loaded succesfully');

			// 	this.loaded = true;
			// }));
	}


  // async	getNetsolinparam():  Promise<Observable<any>> {
  //   NetsolinApp.objenvrestddtabla.usuario = this.globalfb.user.id;
  //   NetsolinApp.objenvrestddtabla.psw = NetsolinApp.oapp.cuserpsw;
  //   NetsolinApp.objenvrestddtabla.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
  //   NetsolinApp.objenvrestddtabla.tokenfb = await this.oauth.getAuthToken();
  //     console.log('netsoliservice ',NetsolinApp.objenvrestddtabla);
	// 	return this.http.post(NetsolinApp.urlNetsolin + "netsolin_servirestgo.csvc?VRCod_obj=RESTACTPARAMEMPRE", NetsolinApp.objenvrestddtabla)
	// 	.pipe(
	// 	map(resul => {
	// 		console.log('getNetsolinparam resul',resul);
	// 		return resul;
	// 	})
	// 	);
	// }
//op oct 4 22 carga array con modelos de distri x cc si lo hay
async cargaModeldistriNetsolin(){
  var nomcolstorage = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin +'_ModelDistriNetsolin';
  this.svstorage.getReg('Tablas', 'id', nomcolstorage, {}).then(resp =>{
    if (resp.length>0){
      this.modelos_dist = resp[0].registros;
      this.cargo_modeldis = true;
      return;
    } else {
      this.cargarModeldistriPost(nomcolstorage);
    }
  })
}

async cargarModeldistriPost(nomcolstorage){
  var filtro = '*';
  this.cargo_modeldis = false;
  var objllama = { ...NetsolinApp.objenvrestsolcomobog};
      objllama.tabla = "dis_porcmodc";
      objllama.orden = 'cod_modist';
      objllama.aplica = 0;
      objllama.filtroadi = filtro;
      objllama.filtro = filtro;
      objllama.campollave = 'cod_modist';
      objllama.campos = "cod_modist,cod_modist as id,descripcion,descripcion as text";
      objllama.llave = '';
      objllama.tokenfb = await this.oauth.getAuthToken();
      this.ult_tokenfb = objllama.tokenfb;
      objllama.cursor = "Tcursorx";
  objllama.en_prod ='NOPROD';
  this.getNetsolinmodelosdistri(objllama).then(sub=> sub
    .subscribe((result: any) => {
      if (result.isCallbackError){
        console.log('Error al traer modelos distribución',result.messages)
      } else {
      console.log('resul modelos distri',result);
      this.modelos_dist = result;
      var madi ={cod_modist: 'ADXCUENTA', id: 'ADXCUENTA', descripcion: 'USAR DISTRIBUCIÓN X CUENTA', text: 'USAR DISTRIBUCIÓN X CUENTA'};
      this.modelos_dist.unshift(madi);
      this.cargo_modeldis = true;
        var parstorage = {
          id: nomcolstorage,
          prefijo: this.globalfb.empresa.parNetsolin.prefijoemprenetsolin,
          tabla: 'DIS_PORCMODC',
          registros: this.modelos_dist
        }
        this.svstorage.addReg('Tablas', parstorage)
      }
    }));
}
async	getNetsolinmodelosdistri(pobjllama:any) : Promise<Observable<any>> {
  pobjllama.usuario = this.globalfb.user.id;
  pobjllama.psw = NetsolinApp.oapp.cuserpsw;
  pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
  pobjllama.tokenfb = await this.oauth.getAuthToken();
  this.ult_tokenfb = pobjllama.tokenfb;
  return this.http.post(NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc", pobjllama)
		.pipe(
		map(resul => {
			return resul;
		})
		);
	}
//op oct 4 22 carga array con empleados terceros marcados como empleados
async cargaEmpleadosNetsolin(){
  var nomcolstorage = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin +'_EmpleadosNetsolin';
  this.svstorage.getReg('Tablas', 'id', nomcolstorage, {}).then(resp =>{
    if (resp.length>0){
      this.empleados = resp[0].registros;
      this.cargo_emple = true;
      return;
    } else {
      this.cargarEmpleadosPost(nomcolstorage);
    }
  })
}

async cargarEmpleadosPost(nomcolstorage){
  var filtro = NetsolinApp.oapp.motor==3 ? 'empleado=1' : 'empleado=true';
  this.cargo_emple = false;
  var objllama = { ...NetsolinApp.objenvrestsolcomobog};
      objllama.tabla = "terceros";
      objllama.orden = 'cod_tercer';
      objllama.aplica = 0;
      objllama.filtroadi = filtro;
      objllama.filtro = filtro;
      objllama.campollave = 'cod_tercer';
      objllama.campos = "cod_tercer,cod_tercer as id,nombre,nombre as text";
      objllama.llave = '';
      objllama.tokenfb = await this.oauth.getAuthToken();
      this.ult_tokenfb = objllama.tokenfb;
      objllama.cursor = "Tcursorx";
  objllama.en_prod ='NOPROD';
  this.getNetsolinempleados(objllama).then(sub=> sub
    .subscribe((result: any) => {
      if (result.isCallbackError){
        console.log('Error al traer empleados',result.messages)
      } else {
      // console.log('resul cen costos',result);
      this.empleados = result;
      this.cargo_emple = true;
        var parstorage = {
          id: nomcolstorage,
          prefijo: this.globalfb.empresa.parNetsolin.prefijoemprenetsolin,
          tabla: 'empleados',
          registros: this.empleados
        }
        this.svstorage.addReg('Tablas', parstorage)
      }
    }));
}
async	getNetsolinempleados(pobjllama:any) : Promise<Observable<any>> {
  pobjllama.usuario = this.globalfb.user.id;
  pobjllama.psw = NetsolinApp.oapp.cuserpsw;
  pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
  pobjllama.tokenfb = await this.oauth.getAuthToken();
  this.ult_tokenfb = pobjllama.tokenfb;
  return this.http.post(NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc", pobjllama)
		.pipe(
		map(resul => {
			return resul;
		})
		);
	}
	//op feb 18 22 carga array con documentos netsolin para combox
	async cargaCencostosNetsolin(){
		// console.log('cargando documento netsolin');
    var nomcolstorage = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin +'_CencostosNetsolin';
    this.svstorage.getReg('Tablas', 'id', nomcolstorage, {}).then(resp =>{
      // console.log('resp storagecencostos',resp);
      if (resp.length>0){
				this.cen_costos = resp[0].registros;
        // console.log('trae de storagecencostos this.cen_costos:',this.cen_costos);
        this.cargo_cc = true;
				this.centros = this.cen_costos.filter(o => o.subcentro === '').map(reg => ({ id: reg.centro,nombre:reg.nombre,text:reg.nombre}));
				// console.log('this.centros:',this.centros);
        return;
      } else {
        // console.log('resp a crearcencostos');
        this.cargarCencostosPost(nomcolstorage);
      }
    })
	}

  async cargarCencostosPost(nomcolstorage){
    let filtro ='*';
    this.cargo_cc = false;
		var objllama = { ...NetsolinApp.objenvrestsolcomobog};
		// objllama.usuario = NetsolinApp.oapp.cuserid;
        // objllama.psw = NetsolinApp.oapp.cuserpsw;
        // objllama.prefijobd = NetsolinApp.oapp.prefijo_sqlbd;
        objllama.tabla = "cen_costos";
        objllama.orden = 'centro';
        objllama.aplica = 0;
        objllama.filtroadi = filtro;
        objllama.filtro = filtro;
        objllama.campollave = 'cod_docume';
        objllama.campos = "centro,subcentro,centro as id,nombre,nombre as text";
        objllama.llave = '';
        objllama.tokenfb = await this.oauth.getAuthToken();
        this.ult_tokenfb = objllama.tokenfb;
        objllama.cursor = "Tcursorx";
		objllama.en_prod ='NOPROD';
		// NetsolinApp.urlNetsolin = "http://40.85.161.231/CERCANOSREST/";
		// console.log('cargando cencostos netsolin objllama ',objllama,this.globalfb.user,this.globalfb.phs[this.globalfb.currentPH]);
		// this.cargobasenetsolin=true;
		this.getNetsolincencostos(objllama).then(sub=> sub
			.subscribe((result: any) => {
				if (result.isCallbackError){
					console.log('Error al traer centros de costos',result.messages)
				} else {
				// console.log('resul cen costos',result);
				this.cen_costos = result;
        this.cargo_cc = true;
				// this.centros = this.cen_costos.filter(o => o.subcentro === '').map(reg => ({ id: reg.centro,centro:reg.centro,nombre:reg.nombre,text:reg.nombre}));
				this.centros = this.cen_costos.filter(o => o.subcentro === '').map(reg => ({ id: reg.centro,nombre:reg.nombre,text:reg.nombre}));
				// console.log('this.centros:',this.centros);
          var parstorage = {
            id: nomcolstorage,
            prefijo: this.globalfb.empresa.parNetsolin.prefijoemprenetsolin,
            tabla: 'cen_costos',
            registros: this.cen_costos
          }
          // console.log('resp trajeo y va a crear cen costos en storage parstorage: ',parstorage);
          this.svstorage.addReg('Tablas', parstorage)
				}
// let scc = ccs.filter(o => o.centro === 'VTA' && o.subcentro !='').map(reg => ({ id: reg.subcentro,centro:reg.centro,subcentro:reg.subcentro,nombre:reg.nombre,text:reg.nombre}));
			}));
  }

async	getNetsolincencostos(pobjllama:any) : Promise<Observable<any>> {
  pobjllama.usuario = this.globalfb.user.id;
  pobjllama.psw = NetsolinApp.oapp.cuserpsw;
  pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
  pobjllama.tokenfb = await this.oauth.getAuthToken();
  this.ult_tokenfb = pobjllama.tokenfb;
  return this.http.post(NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc", pobjllama)
		.pipe(
		map(resul => {
			// console.log('getNetsolincencostos resul',resul);
			return resul;
		})
		);
	}

	//op Marzo 17 22 buscaa obligacion cartera cxp r retorna registro
  async	getNetsolinobliga(pobjllama:any): Promise<Observable<any>> {
    pobjllama.usuario = this.globalfb.user.id;
    pobjllama.psw = NetsolinApp.oapp.cuserpsw;
    pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
    pobjllama.tokenfb = await this.oauth.getAuthToken();
    this.ult_tokenfb = pobjllama.tokenfb;
		// console.log('getNetsolinobliga: ',NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc", pobjllama);
		return this.http.post(NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc", pobjllama)
		.pipe(
		map(resul => {
			// console.log('getNetsolinobliga resul',resul);
			return resul;
		})
		);
	}
//OP MARZ 1 22 CARGA ACUMULADORES
	cargaAcumuladoresNetsolin(){
		// console.log('cargando acumuladores netsolin');
    var nomcolstorage = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin +'_AcumuladoresNetsolin';
    this.svstorage.getReg('Tablas', 'id', nomcolstorage, {}).then(resp =>{
      // console.log('resp storage cargaAcumuladoresNetsolin',resp);
      if (resp.length>0){
				this.acumuladorestodos = resp[0].registros;
        // console.log('trae de storage cargaAcumuladoresNetsolin this.for_pago:',this.acumuladorestodos);
        this.cargo_acum = true;
        return;
      } else {
        // console.log('resp a crear cargaAcumuladoresNetsolin');
        this.cargaAcumuladorPost(nomcolstorage);
      }
    })
	}
  cargaAcumuladorPost(nomcolstorage){
    let filtro = '*';
    this.cargo_acum = false;
		var objllama = { ...NetsolinApp.objenvrestsolcomobog};
        objllama.tabla = "acumuladores";
        objllama.orden = 'cod_acum';
        objllama.aplica = 0;
        objllama.filtroadi = filtro;
        objllama.filtro = filtro;
        objllama.campollave = 'cod_acum';
        objllama.campos = "cod_tipo,cod_acum,cod_acum as id,valor,valor as text";
        objllama.llave = '';
        objllama.cursor = "Tcursorx";
		objllama.en_prod ='NOPROD';
		// console.log('cargando acumuladores netsolin llamado con ',objllama);
		// this.cargobasenetsolin=true;
		this.getNetsolinacumuladores(objllama).then(sub=> sub
			.subscribe((result: any) => {
				// console.log('resul acumuladores ',result);
				if (result.isCallbackError){
					console.log('Error al traer acumuladores',result.messages)
				} else {
					this.acumuladorestodos = result;
					// console.log('this.acumuladorestodos:',this.acumuladorestodos);
          this.cargo_acum = true;
            var parstorage = {
              id: nomcolstorage,
              prefijo: this.globalfb.empresa.parNetsolin.prefijoemprenetsolin,
              tabla: 'acumuladores',
              registros: this.acumuladorestodos
            }
            // console.log('resp trajeo y va a crear monedas en storage parstorage: ',parstorage);
            this.svstorage.addReg('Tablas', parstorage)
          }
				// this.acumuladores = this.cen_costos.filter(o => o.subcentro === '').map(reg => ({ id: reg.centro,nombre:reg.nombre,text:reg.nombre}));
			}));
  }
async getNetsolinacumuladores(pobjllama:any): Promise<Observable<any>> {
      pobjllama.usuario = this.globalfb.user.id;
      pobjllama.psw = NetsolinApp.oapp.cuserpsw;
      pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
      pobjllama.tokenfb = await this.oauth.getAuthToken();
      this.ult_tokenfb = pobjllama.tokenfb;
      // console.log('pobjllama para acumuladores http',pobjllama);
		return this.http.post(NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc", pobjllama)
		.pipe(
		map(resul => {
			// console.log('getNetsolinacumuladores resul',resul);
			return resul;
		})
		);
	}

	//OP MARZ 1 22 CARGA ACUMULADORES
	cargaCoddinamicosNetsolin(){
		// console.log('cargando cargaCoddinamicosNetsolin netsolin');
    var nomcolstorage = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin +'_CoddinamicosNetsolin';
    var crear = false;
    this.svstorage.getReg('Tablas', 'id', nomcolstorage, {}).then(resp =>{
      // console.log('resp storage CoddinamicosNetsolin',resp);
      if (resp.length>0){
				this.coddinam = resp[0].registros;
        // console.log('trae de storage CoddinamicosNetsolin this.for_pago:',this.coddinam);
        this.cargo_coddinam = true;
        return;
      } else {
        // console.log('resp a crear CoddinamicosNetsolin');
        // crear = true;
        this.cargaCoddinamicosPost(nomcolstorage);
      }
    })
	}
  cargaCoddinamicosPost(nomcolstorage){
    let filtro ='*';
    this.cargo_coddinam = false;
		var objllama = { ...NetsolinApp.objenvrestsolcomobog};
        objllama.tabla = "cod_dinamicos";
        objllama.orden = 'cod_dinam';
        objllama.aplica = 0;
        objllama.filtroadi = filtro;
        objllama.filtro = filtro;
        objllama.campollave = 'cod_dinam';
        objllama.campos = "cod_dinam,cod_dinam as id,nombre,nombre as text";
        objllama.llave = '';
        objllama.cursor = "Tcursorx";
		objllama.en_prod ='NOPROD';
		// console.log('cargando dinamicos netsolin llamado con objllama,',objllama,NetsolinApp.objenvrestsolcomobog);
		// this.cargobasenetsolin=true;
		this.getNetsolincoddinamicos(objllama).then(sub=> sub
			.subscribe((result: any) => {
				if (result.isCallbackError){
					console.log('Error al traer codigos dinamicos',result.messages)
				} else {
				// console.log('resul dinamicos ',result);
				this.coddinam = result;
				// console.log('this.coddinam:',this.coddinam);
        this.cargo_coddinam = true;
          var parstorage = {
            id: nomcolstorage,
            prefijo: this.globalfb.empresa.parNetsolin.prefijoemprenetsolin,
            tabla: 'coddinam',
            registros: this.coddinam
          }
          // console.log('resp trajeo y va a crear coddinam en storage parstorage: ',parstorage);
          this.svstorage.addReg('Tablas', parstorage);
      }
			}));
  }
async getNetsolincoddinamicos(pobjllama:any): Promise<Observable<any>> {
      pobjllama.usuario = this.globalfb.user.id;
      pobjllama.psw = NetsolinApp.oapp.cuserpsw;
      pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
      pobjllama.tokenfb = await this.oauth.getAuthToken();
      this.ult_tokenfb = pobjllama.tokenfb;
      // console.log('pobjllama para cod dinamicos http',pobjllama);
		return this.http.post(NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc", pobjllama)
		.pipe(
		map(resul => {
			// console.log('getNetsolincoddinamicos resul',resul);
			return resul;
		})
		);
	}
async getNetsolinReferProve(pobjllama:any): Promise<Observable<any>> {
      pobjllama.usuario = this.globalfb.user.id;
      pobjllama.psw = NetsolinApp.oapp.cuserpsw;
      pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
      pobjllama.tokenfb = await this.oauth.getAuthToken();
      this.ult_tokenfb = pobjllama.tokenfb;
      // console.log('pobjllama para cod dinamicos http',pobjllama);
		return this.http.post(NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc", pobjllama)
		.pipe(
		map(resul => {
			// console.log('getNetsolincoddinamicos resul',resul);
			return resul;
		})
		);
	}
	//op abril 19 22 carga array con documentos soporte netsolin para combox
	//op abril 19 22 carga array con documentos soporte netsolin para combox
	cargaDocsoporteNetsolin(ptipo:any){
		var filtro = ptipo == 'D' ? 'docsopere=true' : 'tipdocsaj=true';
    if (ptipo=='D')
      this.cargo_dsop = false;
    else
      this.cargo_dsopa = false;
    if (NetsolinApp.oapp.motor==3)
      filtro = ptipo == 'D' ? 'docsopere=1' : 'tipdocsaj=1';
		// console.log('cargando documento netsolin');
    var nomtabla = ptipo == 'D' ? 'docsoporte' : 'docsoporteaj';
    var nomcolstorage = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin +'_'+nomtabla;
    this.svstorage.getReg('Tablas', 'id', nomcolstorage, {}).then(resp =>{
      if (resp.length>0){
        if (ptipo=='D'){
				  this.docsoporte = resp[0].registros;
          this.cargo_dsop = true;
        }
        else{
           this.docsoporteaj = resp[0].registros;
           this.cargo_dsopa = true;
          }
          // this.cargobasenetsolin=true;
          // console.log('resp storage CARGO this.docsoporte,this.docsoporteaj',resp,this.docsoporte,this.docsoporteaj);
          return;
    } else {
        // console.log('resp a crear tipo docum');
        this.cargaDocSoportePost(filtro,nomcolstorage,ptipo,nomtabla);
      }
    })
	}
  cargaDocSoportePost(filtro,nomcolstorage,ptipo,nomtabla){
    var objllama = { ...NetsolinApp.objenvrestsolcomobog};

		// objllama.usuario = NetsolinApp.oapp.cuserid;
        // objllama.psw = NetsolinApp.oapp.cuserpsw;
        // objllama.prefijobd = NetsolinApp.oapp.prefijo_sqlbd;
        objllama.tabla = "documentos";
        objllama.orden = 'cod_docume';
        objllama.aplica = 0;
        objllama.filtroadi = filtro;
        objllama.filtro = filtro;
        objllama.campollave = 'cod_docume';
        objllama.campos = "cod_docume as cod_dsopor,cod_docume as id,nombre,nombre as text";
        objllama.llave = '';
        objllama.cursor = "Tcursorx";
		objllama.en_prod ='NOPROD';
		// NetsolinApp.urlNetsolin = "http://40.85.161.231/CERCANOSREST/";
		// console.log('cargando documento netsolin llamado con ',NetsolinApp);
		// this.cargobasenetsolin=true;
		this.getNetsolindocs(objllama).then(sub=> sub
		.subscribe((result: any) => {
			if (result.isCallbackError){
				console.log('Error al traer documentos',result.messages)
			} else {
				// console.log('resul documentos',ptipo,result);
        if (ptipo=='D'){
				  this.docsoporte = result;
          this.cargo_dsop = true;
        }
        else{
           this.docsoporteaj = result;
           this.cargo_dsopa = true;
          }
          // console.log('POST CARGO this.docsoporte,this.docsoporteaj',result,this.docsoporte,this.docsoporteaj);
            var parstorage = {
              id: nomcolstorage,
              prefijo: this.globalfb.empresa.parNetsolin.prefijoemprenetsolin,
              tabla: nomtabla,
              registros: ptipo == 'D' ? this.docsoporte : this.docsoporteaj
            }
            // console.log('resp trajeo y va a crear tipo docs en storage parstorage: ',parstorage);
            this.svstorage.addReg('Tablas', parstorage)


			}
			}));
  }
	//op feb 18 22 carga array con documentos netsolin para combox
	cargaDocumentoNetsolin(){
		let filtro ='*';
		// console.log('cargando documento netsolin');
		var objllama = { ...NetsolinApp.objenvrestsolcomobog};

		// objllama.usuario = NetsolinApp.oapp.cuserid;
        // objllama.psw = NetsolinApp.oapp.cuserpsw;
        // objllama.prefijobd = NetsolinApp.oapp.prefijo_sqlbd;
        objllama.tabla = "documentos";
        objllama.orden = 'cod_docume';
        objllama.aplica = 0;
        objllama.filtroadi = filtro;
        objllama.filtro = filtro;
        objllama.campollave = 'cod_docume';
        objllama.campos = "cod_docume as cod_dsopor,cod_docume as id,nombre,nombre as text";
        objllama.llave = '';
        objllama.cursor = "Tcursorx";
		objllama.en_prod ='NOPROD';
		// NetsolinApp.urlNetsolin = "http://40.85.161.231/CERCANOSREST/";
		// console.log('cargando documento netsolin llamado con ',NetsolinApp);
		// this.cargobasenetsolin=true;
		this.getNetsolindocs(objllama).then(sub=> sub
		.subscribe((result: any) => {
			if (result.isCallbackError){
				console.log('Error al traer documentos',result.messages)
			} else {
				// console.log('resul documentos',result);
				this.documentos = result;
			}
			}));
	}


	cargaFormaspagoNetsolin(){
		// console.log('cargando documento netsolin');
    var nomcolstorage = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin +'_FormaspagoNetsolin';
    var crear = false;
    this.svstorage.getReg('Tablas', 'id', nomcolstorage, {}).then(resp =>{
      // console.log('resp storage form pago',resp);
      if (resp.length>0){
				this.for_pago = resp[0].registros;
        console.log('trae de storage form pago this.for_pago:',this.for_pago);
        this.cargo_formpago = true;
        return;
      } else {
        // console.log('resp a crear form pago');
        this.cargarFormaspagoPost(nomcolstorage);
      }
    })
	}
  cargarFormaspagoPost(nomcolstorage){
    let filtro ='*';
    this.cargo_formpago = false;
		var objllama = { ...NetsolinApp.objenvrestsolcomobog};

        objllama.tabla = "for_pago";
        objllama.orden = 'cod_fpago';
        objllama.aplica = 0;
        objllama.filtroadi = filtro;
        objllama.filtro = filtro;
        objllama.campollave = 'cod_fpago';
        objllama.campos = "cod_fpago as id,nombre,nombre as text";
        objllama.llave = '';
        objllama.cursor = "Tcursorx";
		objllama.en_prod ='NOPROD';
		// NetsolinApp.urlNetsolin = "http://40.85.161.231/CERCANOSREST/";
		// console.log('cargando documento netsolin llamado con ',NetsolinApp);
		// this.cargobasenetsolin=true;
		this.getNetsolinformaspago(objllama).then(sub=> sub
		.subscribe((result: any) => {
			if (result.isCallbackError){
				console.log('Error al traer formas pago',result.messages)
			} else {
				// console.log('resul formas pago',result);
				this.for_pago = result;
        this.cargo_formpago = true;
          var parstorage = {
            id: nomcolstorage,
            prefijo: this.globalfb.empresa.parNetsolin.prefijoemprenetsolin,
            tabla: 'for_pago',
            registros: this.for_pago
          }
          // console.log('resp trajeo y va a crear form pago en storage parstorage: ',parstorage);
          this.svstorage.addReg('Tablas', parstorage)


			}
			}));
  }
async getNetsolinformaspago(pobjllama:any): Promise<Observable<any>> {
      pobjllama.usuario = this.globalfb.user.id;
      pobjllama.psw = NetsolinApp.oapp.cuserpsw;
      pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
      pobjllama.tokenfb = await this.oauth.getAuthToken();
      this.ult_tokenfb = pobjllama.tokenfb;
      return this.http.post(NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc", pobjllama)
		.pipe(
		map(resul => {
			// console.log('cargaDocumentoNetsolin resul',resul);
			return resul;
		})
		);
	}
	//op feb 18 22 carga array con documentos netsolin para combox
	cargaMonedasNetsolin(){
		// console.log('cargando documento netsolin');
    var nomcolstorage = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin +'_MonedasNetsolin';
    var crear = false;
    this.svstorage.getReg('Tablas', 'id', nomcolstorage, {}).then(resp =>{
      // console.log('resp storage MonedasNetsolin',resp);
      if (resp.length>0){
				this.amonedas = resp[0].registros;
        // console.log('trae de storage MonedasNetsolin this.for_pago:',this.for_pago);
        this.cargo_monedas = true;
        return;
      } else {
        // console.log('resp a crear MonedasNetsolin');
        this.cargarMonedasPost(nomcolstorage);
      }
    })
	}
  cargarMonedasPost(nomcolstorage){
    let filtro ='*';
    this.cargo_monedas = false;
		var objllama = { ...NetsolinApp.objenvrestsolcomobog};

        objllama.tabla = "monedas";
        objllama.orden = 'cod_mone';
        objllama.aplica = 0;
        objllama.filtroadi = filtro;
        objllama.filtro = filtro;
        objllama.campollave = 'cod_mone';
        objllama.campos = "cod_mone, cod_mone as id,nombre,nombre as text";
        objllama.llave = '';
        objllama.cursor = "Tcursorx";
		objllama.en_prod ='NOPROD';
		// NetsolinApp.urlNetsolin = "http://40.85.161.231/CERCANOSREST/";
		// console.log('cargando documento netsolin llamado con ',NetsolinApp);
		// this.cargobasenetsolin=true;
		this.getNetsolinmonedas(objllama).then(sub=> sub
		.subscribe((result: any) => {
			if (result.isCallbackError){
				console.log('Error al traer monedas',result.messages)
			} else {
				// console.log('resul monedas',result);
				this.amonedas = result;
        this.cargo_monedas = true;
          var parstorage = {
            id: nomcolstorage,
            prefijo: this.globalfb.empresa.parNetsolin.prefijoemprenetsolin,
            tabla: 'amonedas',
            registros: this.amonedas
          }
          // console.log('resp trajeo y va a crear monedas en storage parstorage: ',parstorage);
          this.svstorage.addReg('Tablas', parstorage)
			}
			}));
  }
async getNetsolinmonedas(pobjllama:any): Promise<Observable<any>> {
      pobjllama.usuario = this.globalfb.user.id;
      pobjllama.psw = NetsolinApp.oapp.cuserpsw;
      pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
      pobjllama.tokenfb = await this.oauth.getAuthToken();
      this.ult_tokenfb = pobjllama.tokenfb;
      return this.http.post(NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc", pobjllama)
		.pipe(
		map(resul => {
			// console.log('getNetsolin monedas resul',resul);
			return resul;
		})
		);
	}




async getNetsolindocs(pobjllama:any): Promise<Observable<any>> {
      pobjllama.usuario = this.globalfb.user.id;
      pobjllama.psw = NetsolinApp.oapp.cuserpsw;
      pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
      pobjllama.tokenfb = await this.oauth.getAuthToken();
      this.ult_tokenfb = pobjllama.tokenfb;
      return this.http.post(NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc", pobjllama)
		.pipe(
		map(resul => {
			// console.log('cargaDocumentoNetsolin resul',resul);
			return resul;
		})
		);
	}

		//op aBRIL  10 22 carga array con AÑOS INICIALIZADOS
		cargaAnosiniNetsolin(){
      var nomcolstorage = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin +'_AnosiniNetsolin';
      var crear = false;
      this.svstorage.getReg('Tablas', 'id', nomcolstorage, {}).then(resp =>{
        // console.log('resp storage AnosiniNetsolin',resp);
        if (resp.length>0){
          this.anosini = resp[0].registros;
          // console.log('trae de storage AnosiniNetsolin this.anosini:',this.anosini);
          this.cargo_anosini = true;
          return;
        } else {
          // console.log('resp a crear AnosiniNetsolin');
          this.cargarAnosiniPost(nomcolstorage);
        }
      })
		}
    cargarAnosiniPost(nomcolstorage){
      let filtro ='aplicacion=1';
      this.cargo_anosini = false;
			// console.log('cargando años netsolin');
			var objllama = { ...NetsolinApp.objenvrestsolcomobog};
			objllama.tabla = "est_aplica";
			objllama.orden = 'ano';
			objllama.aplica = 0;
			objllama.filtroadi = filtro;
			objllama.filtro = filtro;
			objllama.campollave = 'ano';
			objllama.campos = "ano as id,ano,ano as text";
			objllama.llave = '';
			objllama.cursor = "Tcursorx";
			objllama.en_prod ='NOPROD';
			// this.cargobasenetsolin=true;
			this.getNetsolinanosini(objllama).then(sub=> sub
			.subscribe((result: any) => {
				if (result.isCallbackError){
					console.log('Error al traer anos',result.messages)
				} else {
					// console.log('resul anos',result);
					this.anosini = result;
          this.cargo_anosini = true;
            var parstorage = {
              id: nomcolstorage,
              prefijo: this.globalfb.empresa.parNetsolin.prefijoemprenetsolin,
              tabla: 'anosini',
              registros: this.anosini
            }
            // console.log('resp trajeo y va a crear anosini en storage parstorage: ',parstorage);
            this.svstorage.addReg('Tablas', parstorage)
        }
				}));
    }
    async getNetsolinanosini(pobjllama:any): Promise<Observable<any>> {
      pobjllama.usuario = this.globalfb.user.id;
      pobjllama.psw = NetsolinApp.oapp.cuserpsw;
      pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
      pobjllama.tokenfb = await this.oauth.getAuthToken();
      this.ult_tokenfb = pobjllama.tokenfb;
			return this.http.post(NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc", pobjllama)
			.pipe(
			map(resul => {
				// console.log('cargaDocumentoNetsolin resul',resul);
				return resul;
			})
			);
		}





async getModulosNetsolin() {
  var objllama = { ...NetsolinApp.modulos};
  objllama.usuario = this.globalfb.user.id;
        objllama.psw = NetsolinApp.oapp.cuserpsw;
        objllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
      objllama.tokenfb = await this.oauth.getAuthToken();
      // NetsolinApp.urlNetsolin = "http://40.85.161.231/CERCANOSREST/";
    // console.log('getModulosNetsolin llamado con objllama:',objllama);
    console.warn('MODULOSWEB objllama:',objllama);
    var nomcolstorage = objllama.prefijobd+'_MODULOSWEB';
    var crear = true;
    var resulstorage: any;
    return this.svstorage.getReg('Tablas', 'id', nomcolstorage, {}).then(async resp =>{
      console.warn('resp storage MODULOSWEB',resp);
      if (resp.length>0){
        console.warn('trae de storage MODULOSWEB this.for_pago:',resp[0].registros);
        resulstorage =resp[0].registros;
        crear = false;
        return resulstorage;
      } else{
        return await this.http
        .post(
				NetsolinApp.urlNetsolin + "netsolin_servirestgo.csvc?VRCod_obj=MODULOSWEB",
				objllama
        ).pipe(first()).toPromise().then((resul: any) => {
				console.log('getModulosNetsolin resul:',resul);
        var parstorage = {
          id: nomcolstorage,
          prefijo: this.globalfb.empresa.parNetsolin.prefijoemprenetsolin,
          tabla: 'MODULOSWEB',
          registros: resul
        }
        console.log('resp trajeo y va a crear form pago en storage parstorage: ',parstorage);
        this.svstorage.addReg('Tablas', parstorage)
				return resul;
      })
    }
  })
}

  async	getSubModuloNetsolin(aplicacion: number): Promise<any> {
    var objllama = { ...NetsolinApp.modulos};
    objllama.usuario = this.globalfb.user.id;
          objllama.psw = NetsolinApp.oapp.cuserpsw;
          objllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
        objllama.tokenfb = await this.oauth.getAuthToken();
      objllama.aplica = aplicacion;
      // console.warn('MANTABLAS objllama:',objllama);
      var nomcolstorage = objllama.prefijobd+'_MANTABLAS_'+aplicacion;
      var crear = true;
      var resulstorage: any;
      return this.svstorage.getReg('Tablas', 'id', nomcolstorage, {}).then(async resp =>{
        // console.warn('resp storage MANTABLAS',resp);
        if (resp.length>0){
          // console.warn('trae de storage MANTABLAS :',resp[0].registros);
          resulstorage =resp[0].registros;
          crear = false;
          // console.warn('crear a falso en MANTABLAS crear:',crear);
          return resulstorage;
        } else{
          return await this.http
          .post(
            NetsolinApp.urlNetsolin + "netsolin_servirestgo.csvc?VRCod_obj=MANTABLAS",
            objllama
          ).pipe(first()).toPromise().then((res: any) => {
            var parstorage = {
              id: nomcolstorage,
              prefijo: this.globalfb.empresa.parNetsolin.prefijoemprenetsolin,
              tabla: 'MANTABLAS',
              registros: res
            }
            // console.log('resp MANTABLAS trajeo y va a crear  en storage parstorage: ',parstorage);
            this.svstorage.addReg('Tablas', parstorage)
              return res;
          })
        }
      })
	}

  async	getModulosWebSolinNetsolin() {
    var objllama = { ...NetsolinApp.modulos};
    objllama.usuario = this.globalfb.user.id;
    objllama.psw = NetsolinApp.oapp.cuserpsw;
    objllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
  objllama.tokenfb = await this.oauth.getAuthToken();
    // console.log('getModulosWebSolinNetsolin  objllama', NetsolinApp);
    // console.warn('MODULOSWEBSOLIN objllama:',objllama);
    var nomcolstorage = objllama.prefijobd+'_MODULOSWEBSOLIN';
    var crear = true;
    var resulstorage: any;
    return this.svstorage.getReg('Tablas', 'id', nomcolstorage, {}).then(async resp =>{
      // console.warn('resp storage MODULOSWEBSOLIN',resp);
      if (resp.length>0){
        // console.warn('trae de storage MODULOSWEBSOLIN this.for_pago:',resp[0].registros);
        resulstorage =resp[0].registros;
        crear = false;
        return resulstorage;
      } else{
        return await this.http
        .post(
				NetsolinApp.urlNetsolin + "netsolin_servirestgo.csvc?VRCod_obj=MODULOSWEBSOLIN",
				objllama
        ).pipe(first()).toPromise().then((resul: any) => {
				// console.log('getModulosWebSolinNetsolin resul',resul);
        var parstorage = {
          id: nomcolstorage,
          prefijo: this.globalfb.empresa.parNetsolin.prefijoemprenetsolin,
          tabla: 'MODULOSWEBSOLIN',
          registros: resul
        }
        // console.log('resp trajeo y va a crear form pago en storage parstorage: ',parstorage);
        this.svstorage.addReg('Tablas', parstorage)
        return resul;
      })
    }
  })
}

//Consulta en Netsolin el usuario con la fecha para saber que ruta y periodo le corresponde
// cargaPeriodoUsuar(pcod_usuar){
// 	console.log('cargaPeriodoUsuar 1',pcod_usuar);
// 	return new Promise((resolve)=>{
// 		console.log('cargaPeriodoUsuar 2',pcod_usuar);
// 		// if (this.cargoidperiodo){
// 		// 	console.log('cargaPeriodoUsuar 3',pcod_usuar);
// 		// 	resolve(true);
// 		//  }
// 		NetsolinApp.objenvrest.filtro = pcod_usuar;
// 		let url= NetsolinApp.urlNetsolin + "netsolin_servirestgo.csvc?VRCod_obj=IDRUTAPERAPP";
// 		console.log('cargaPeriodoUsuar 4',pcod_usuar,url,NetsolinApp.objenvrest);
// 		this.http.post( url, NetsolinApp.objenvrest )
// 			 .subscribe( (data:any) =>{
// 				console.log('cargaPeriodoUsuar 41',pcod_usuar);
// 				console.log('cargo periodo en netsolin', data);
// 				if( data.error){
// 					console.log('cargaPeriodoUsuar 42',pcod_usuar);
// 					console.error(" cargaPeriodoUsuar ", data.error);
// 					//   this._parempre.reg_log('Error en cargaPeriodoUsuar por netsolin ', 'data.error');
// 					this.cargoidperiodo = false;
// 					this.cargo_ruta = false;
// 					this.error_cargarruta = true;
// 					this.men_errorcargarruta = data.men_error;
// 					resolve(false);
// 					} else{
// 						console.log('cargaPeriodoUsuar 43',pcod_usuar);
// 						// this._parempre.reg_log('coer', 'cargaPeriodoUsuar por netsolin ');
// 						console.log('cargaPeriodoUsuar 5',pcod_usuar,data.datos_ruta[0]);
// 						this.cargoidperiodo = true;
// 						this.id_ruta = data.datos_ruta[0].id_ruta;
// 						this.id_periodo = data.datos_periodo[0].id_per;
// 						resolve(true);
// 					}
// 			 });
// 		 });
// }

	getNetsolinArchIni() {
	}
	// getNetsolinhtmlbase(): Observable<any> {
	// 	// return this.http.get(this.baseUrl+'todo2s.csvc').map(res => res.json());
	// 	// console.log('a netsolinbase traer');
	// 	console.log('netsolinbase urlNetsolin NetsolinApp: '+NetsolinApp.urlNetsolin);
	// 	var paramSolicitud: string="";

	// 	if (environment.production) {
	// 		paramSolicitud=NetsolinApp.urlNetsolin + "netsolinhtmlgenbase.csvc?VRprod=ENPROD";
	// 	} else {
	// 		paramSolicitud=NetsolinApp.urlNetsolin + "netsolinhtmlgenbase.csvc?VRprod=NOPROD";
	// 	}

	// 	// return this.http.get(NetsolinApp.urlNetsolin + "netsolinhtmlgenbase.csvc")
	// 	return this.http.get(paramSolicitud)
	// 		.pipe(
	// 		map(resul => {
	// 			return resul;
	// 		})
	// 		);
	// }
  //html base de netsolin con token firebase
  async	getNetsolinhtmlbasefb(): Promise<Observable<any>> {
		// return this.http.get(this.baseUrl+'todo2s.csvc').map(res => res.json());
		// console.log('a netsolinbase traer');
		// console.log('netsolinbase urlNetsolin NetsolinApp: '+NetsolinApp.urlNetsolin);
		var paramSolicitud: string = "";

		// if (environment.production) {
		// 	paramSolicitud = NetsolinApp.urlNetsolin + "netsolinhtmlgenbasefb.csvc?VRprod=ENPROD";
		// } else {
		// 	paramSolicitud = NetsolinApp.urlNetsolin + "netsolinhtmlgenbasefb.csvc?VRprod=NOPROD";
		// }
		paramSolicitud = NetsolinApp.urlNetsolin + "netsolinhtmlgenbasefb.csvc";
		// console.log('getNetsolinhtmlbasefb paramSolicitud',paramSolicitud);
    let filtro ='*';
		var objllama = { ...NetsolinApp.objenvrestsolcomobog};
		  objllama.usuario = this.globalfb.user.id;
        // objllama.psw = NetsolinApp.oapp.cuserpsw;
        // objllama.prefijobd = NetsolinApp.oapp.prefijo_sqlbd;
        // objllama.usuario = this.globalfb.user.id;
        objllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
        objllama.tokenfb = await this.oauth.getAuthToken();
        this.ult_tokenfb = objllama.tokenfb;
        objllama.cursor = "Tcursorx";
        // objllama.tokenfb +="1";
    // console.warn('getNetsolinhtmlbasefb objllama',objllama);
    var nomcolstorage = objllama.prefijobd+'_Netsolinhtmlbasefb';
    var crear = true;
    var resulstorage: any;
    return this.svstorage.getReg('Tablas', 'id', nomcolstorage, {}).then(async resp =>{
      // console.warn('resp storage Netsolinhtmlbasefb',resp);
      if (resp.length>0){
        // console.warn('trae de storage Netsolinhtmlbasefb this.for_pago:',resp[0].registros);
        resulstorage =resp[0].registros;
        crear = false;
        return resulstorage;
      } else{
        return await this.http
        .post(
        paramSolicitud,objllama
        ).pipe(first()).toPromise().then((res: any) => {
          var parstorage = {
          id: nomcolstorage,
          prefijo: this.globalfb.empresa.parNetsolin.prefijoemprenetsolin,
          tabla: 'Netsolinhtmlbasefb',
          registros: res
        }
        // console.log('resp trajeo y va a crear form pago en storage parstorage: ',parstorage);
        this.svstorage.addReg('Tablas', parstorage)
        return res;
          })
        }
      })
	}

private handleError(error: HttpErrorResponse) {
		// console.error('Error en servidor:', error);
		if (error.error instanceof Error) {
			let errMessage = error.error.message;
			return Observable.throw(errMessage);
			// Use the following instead if using lite-server
			//return Observable.throw(err.text() || 'backend server error');
		}
		return Observable.throw(error || 'Node.js server error');
	}

	getNetsolinslide(): Observable<any> {
		return this.http.get(NetsolinApp.urlNetsolin + "netsolinmenu.csvc?VRTipo=MTB")
			.pipe(
			map(resul => {
				// console.log('map get');
				//  console.log(resul);
				return resul;
			}),
			catchError(this.handleError)
			);
	}


	getNetsolinMonitores(): Observable<any> {
		return this.http.get(NetsolinApp.urlNetsolin + "netsolinmenu.csvc?VRTipo=CRMI")
			.pipe(
			map(resul => {
				// console.log('map getNetsolinMonitores');
				//  console.log(resul);
				return resul;
			})
			);
	}

	getNetsolinMantbas(ptipo:any, pmodulo:any): Observable<any> {
		return this.http.get(NetsolinApp.urlNetsolin + "netsolinmenu.csvc?VRTipo=" + ptipo + "&VRModulo=" + pmodulo)
			.pipe(
			map(resul => {
				// console.log('map getNetsolinMantbas');
				//  console.log(resul);
				return resul;
			})
			);
	}
	getNetsolinAlertas(): Observable<any> {
		return this.http.get(NetsolinApp.urlNetsolin + "netsolinmenu.csvc?VRTipo=ALERT")
			.pipe(
			map(resul => {
				// console.log('map getNetsolinAlertas');
				//  console.log(resul);
				return resul;
			})
			);
	}
	getNetsolinUsuar(): Observable<any> {
		return this.http.get(NetsolinApp.urlNetsolin + "netsolinmenu.csvc?VRTipo=USUAR")
			.pipe(
			map(resul => {
				console.log('map getNetsolinUsuar resul',resul);
				//  console.log(resul);
				return resul;
			})
			);
	}

	getNetsolinRecordatorio(): Observable<any> {
		return this.http.get(NetsolinApp.urlNetsolin + "netsolinmenu.csvc?VRTipo=SEG")
			.pipe(
			map(resul => {
				return resul;
			})
			);
	}

	getNetsolinProcesos(): Observable<any> {
		return this.http.get(NetsolinApp.urlNetsolin + "netsolinmenu.csvc?VRTipo=PROC")
			.pipe(
			map(resul => {
				// console.log('map getNetsolinProcesos');
				//  console.log(resul);
				return resul;
			})
			);
	}
	getNetsolinSolicitudes(): Observable<any> {
		return this.http.get(NetsolinApp.urlNetsolin + "netsolinmenu.csvc?VRTipo=SOLI")
			.pipe(
			map(resul => {
				// console.log('map getNetsolinSolicitudes');
				//  console.log(resul);
				return resul;
			})
			);
	}


	getNetsolinMessages(): Observable<any> {
		return this.http.get(NetsolinApp.urlNetsolin + "netsolinmenu.csvc?VRTipo=MENS")
			.pipe(
			map(resul => {
				// console.log('map getNetsolinMessages');
				//  console.log(resul);
				return resul;
			})
			);
	}
	getNetsolinSolic(): Observable<any> {
		return this.http.get(NetsolinApp.urlNetsolin + "netsolinmenu.csvc?VRTipo=SOLI")
			.pipe(
			map(resul => {
				return resul;
			})
			);
	}
	/**************************************************/
  getNetsolinDictabla(ptabla:any, paplica:any, pobjeto:any): Observable<any> {
		var objllama = { ...NetsolinApp.objenvrestddtabla};
        NetsolinApp.objenvrestddtabla.usuario = this.globalfb.user.id;
        NetsolinApp.objenvrestddtabla.psw = NetsolinApp.oapp.cuserpsw;
        NetsolinApp.objenvrestddtabla.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
      NetsolinApp.objenvrestddtabla.tabla = ptabla;
		NetsolinApp.objenvrestddtabla.aplica = paplica;
		NetsolinApp.objenvrestddtabla.tokenfb = this.ult_tokenfb;
		// console.log('getNetsolinDictabla ant enviar ');
		// console.log(NetsolinApp.objenvrestddtabla);
    //llamar sin necesidad de logeo
		// return this.http.post(NetsolinApp.urlNetsolin + "Ejeservi_rest.csvc?VRCod_obj=RESTCONDDCAMTAB", NetsolinApp.objenvrestddtabla)
		return this.http.post(NetsolinApp.urlNetsolin + "Ejeservi_rest.csvc?VRCod_obj=RESTCONDDCAMTAB", NetsolinApp.objenvrestddtabla)
			.pipe(
			map(resul => {
				// console.log('getNetsolinDictabla resaulta');
				// console.log(resul);
				return resul;
			})
			);
	}
	//seguridad objeto en netsolin
	getNetsolinSegObj(pobjeto:any): Observable<any> {
		var objllama = { ...NetsolinApp.objenvrestddtabla};
    objllama.usuario = this.globalfb.user.id;
    objllama.psw = NetsolinApp.oapp.cuserpsw;
    objllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
		objllama.tabla = "GENERAL";
		objllama.aplica = 0;
		objllama.objeto = pobjeto;
    objllama.tokenfb = this.ult_tokenfb;
    //llamar sin necesidad de logeo
    // console.warn('RESTCONSEGOBJ objllama:',objllama);
    var nomcolstorage = objllama.prefijobd+'_RESTCONSEGOBJ_' +objllama.objeto;
    return new Observable((observer) => {
      this.svstorage.getReg('Tablas', 'id', nomcolstorage, {}).then(resp => {
        // console.warn('resp storage RESTCONSEGOBJ', resp);
        if (resp.length > 0) {
          // console.warn('trae de storage RESTCONSEGOBJ this.for_pago:', resp[0].registros);
          // return resp[0].registros;
          observer.next(resp[0].registros);
        } else {
          this.segObjetoPost(nomcolstorage,objllama).subscribe((resul) => {
            observer.next(resul);
          });
        }
      })
    });
  }

  segObjetoPost(nomcolstorage, objllama): Observable<any> {
    return this.http.post(NetsolinApp.urlNetsolin + "Ejeservi_rest.csvc?VRCod_obj=RESTCONSEGOBJ", objllama)
            .pipe(
              map((resul: any) => {
                var parstorage = {
                  id: nomcolstorage,
                  prefijo: this.globalfb.empresa.parNetsolin.prefijoemprenetsolin,
                  tabla: 'RESTCONSEGOBJ',
                  registros: resul[0]
                }
                // console.log('resp trajeo y va a crear form pago en storage parstorage: ', parstorage);
                this.svstorage.addReg('Tablas', parstorage)
                return resul[0];
                // return resul;
              })
            );
  }
	//Lee objeto para mant tabla basica
	getNetsolinObjmantbasica(pobjeto:any): Observable<any> {
		var objllama = { ...NetsolinApp.objenvrestddtabla};
    objllama.tabla = "monedas";
    objllama.aplica = 0;
    objllama.tabla = 'GENERAL';
    objllama.objeto = pobjeto;
    // objllama.en_prod ='NOPROD';
    objllama.usuario = this.globalfb.user.id;
    objllama.psw = NetsolinApp.oapp.cuserpsw;
    objllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
    // objllama.tokenfb = await this.oauth.getAuthToken();
    objllama.tokenfb = this.ult_tokenfb;
    //llamar sin necesidad de logeo
		// return this.http.post(NetsolinApp.urlNetsolin + "Ejeservi_rest.csvc?VRCod_obj=RESTOBJMANTBASICA", NetsolinApp.objenvrestddtabla)
    // console.warn('RESTOBJMANTBASICA objllama:',objllama);
    var nomcolstorage = objllama.prefijobd+'_RESTOBJMANTBASICA_' +objllama.objeto;
    return new Observable((observer) => {
    this.svstorage.getReg('Tablas', 'id', nomcolstorage, {}).then(resp =>{
      // console.warn('resp storage RESTOBJMANTBASICA',resp);
      if (resp.length>0){
        // console.warn('trae de storage RESTOBJMANTBASICA this.for_pago:',resp[0].registros);
        // return resp[0].registros;
        observer.next(resp[0].registros);
      }else{
        this.objmantbasicaPost(nomcolstorage,objllama).subscribe((resul) => {
          observer.next(resul);
        });
      }
    })
    });
	}

  objmantbasicaPost(nomcolstorage,objllama){
    return this.http.post(NetsolinApp.urlNetsolin + "Ejeservi_rest.csvc?VRCod_obj=RESTOBJMANTBASICA",objllama)
    .pipe(
      map(resul => {
        // console.warn('Retornado por post RESTOBJMANTBASICA resul:',resul);
        var parstorage = {
          id: nomcolstorage,
          prefijo: this.globalfb.empresa.parNetsolin.prefijoemprenetsolin,
          tabla: 'RESTOBJMANTBASICA',
          registros: resul
        }
        // console.log('resp trajeo y va a crear form pago en storage parstorage: ',parstorage);
        this.svstorage.addReg('Tablas', parstorage)
        return resul;
      })
    );
  }



	//Verifica si variable VPAR... que se usa como parametros en localsotrage este creada si no la crea
	//ejemplo para llamado en monitores sin que tengan que ingresar primero a la tabla basica
	verificaVpar(pobjeto:any,pvarParam:any): Observable<any> {
        NetsolinApp.objenvrestddtabla.usuario = NetsolinApp.oapp.cuserid;
        NetsolinApp.objenvrestddtabla.psw = NetsolinApp.oapp.cuserpsw;
        NetsolinApp.objenvrestddtabla.prefijobd = NetsolinApp.oapp.prefijo_sqlbd;
		NetsolinApp.objenvrestddtabla.tabla = "GENERAL";
		NetsolinApp.objenvrestddtabla.aplica = 0;
		NetsolinApp.objenvrestddtabla.objeto = pobjeto;
		NetsolinApp.objenvrestddtabla.tokenfb = this.ult_tokenfb;
    //llamar sin necesidad de logeo
		// return this.http.post(NetsolinApp.urlNetsolin + "Ejeservi_rest.csvc?VRCod_obj=RESTOBJMANTBASICA", NetsolinApp.objenvrestddtabla)
		return this.http.post(NetsolinApp.urlNetsolin + "Ejeservi_rest.csvc?VRCod_obj=RESTOBJMANTBASICA", NetsolinApp.objenvrestddtabla)
			.pipe(
			map((result:any) => {
				// console.log('map getNetsolinObjmantbasica');
				//  console.log(resul);
				var result0 = result[0];
				// console.log(result0);
				// if (typeof (result.isCallbackError) != "undefined") {
				// 	var  orespuesta: any = {respuesta: "Error"};
				// 	return orespuesta;
				// }

				NetsolinApp.objpartablabas.aplica = parseInt(result0.aplica);
				NetsolinApp.objpartablabas.tabla = result0.tabla;
				NetsolinApp.objpartablabas.campollave = result0.campollave;
				NetsolinApp.objpartablabas.clase_val = result0.clase_val;
				NetsolinApp.objpartablabas.clase_nbs = result0.clase_nbs;
				NetsolinApp.objpartablabas.camponombre = result0.camponombre;
				NetsolinApp.objpartablabas.titulo = result0.title;
				NetsolinApp.objpartablabas.subtitulo = "";
				NetsolinApp.objpartablabas.objeto = pobjeto;
				NetsolinApp.objpartablabas.rutamant = "mantbasica/" + pobjeto;
				NetsolinApp.objpartablabas.prefopermant = result0.prefomant;
				if (result0.campos_lista.length>2){
				  let var3 = JSON.parse(result0.campos_lista);
				  if (typeof(var3)=='object'){
					NetsolinApp.objpartablabas.campos_lista = var3;
				  } else {
						NetsolinApp.objpartablabas.campos_lista = [];
					}
				}
				let var1 = JSON.stringify(NetsolinApp.objpartablabas);
				localStorage.setItem("VPAR" + result0.tabla, var1);

				return result;
				//  return resul[0];
				// return resul;
			})
			);
	}

	verificaVparMal(pobjeto:any,pvarParam:any){
		let lvart: any;
        lvart = localStorage.getItem(pvarParam);
        if (lvart) {
		  // console.log('Existe');
			var  orespuesta: any = {respuesta: "Existe"};
		  	return orespuesta;
        }
        NetsolinApp.objenvrestddtabla.usuario = NetsolinApp.oapp.cuserid;
        NetsolinApp.objenvrestddtabla.psw = NetsolinApp.oapp.cuserpsw;
        NetsolinApp.objenvrestddtabla.prefijobd = NetsolinApp.oapp.prefijo_sqlbd;
		NetsolinApp.objenvrestddtabla.tabla = "GENERAL";
		NetsolinApp.objenvrestddtabla.aplica = 0;
		NetsolinApp.objenvrestddtabla.objeto = pobjeto;
		this.getNetsolinObjmantbasica(pobjeto)
		.subscribe(result =>{
				var result0 = result[0];
				// console.log(result0);
				if (typeof (result.isCallbackError) != "undefined") {
					var  orespuesta: any = {respuesta: "Error"};
					return orespuesta;
				}
				NetsolinApp.objpartablabas.aplica = parseInt(result0.aplica);
				NetsolinApp.objpartablabas.tabla = result0.tabla;
				NetsolinApp.objpartablabas.campollave = result0.campollave;
				NetsolinApp.objpartablabas.clase_val = result0.clase_val;
				NetsolinApp.objpartablabas.clase_nbs = result0.clase_nbs;
				NetsolinApp.objpartablabas.camponombre = result0.camponombre;
				NetsolinApp.objpartablabas.titulo = result0.title;
				NetsolinApp.objpartablabas.subtitulo = "";
				NetsolinApp.objpartablabas.objeto = pobjeto;
				NetsolinApp.objpartablabas.rutamant = "mantbasica/" + pobjeto;
				NetsolinApp.objpartablabas.prefopermant = result0.prefomant;
				if (result0.campos_lista.length>2){
				  let var3 = JSON.parse(result0.campos_lista);
				  if (typeof(var3)=='object'){
					NetsolinApp.objpartablabas.campos_lista = var3;
				  } else {
						NetsolinApp.objpartablabas.campos_lista = [];
					}
				}
				let var1 = JSON.stringify(NetsolinApp.objpartablabas);
				localStorage.setItem("VPAR" + result0.tabla, var1);
				var  orespuesta: any = {respuesta: "Creado"};
				return orespuesta;
			});
	}

	//llama busqueda por objeto envia objeto objenvrest
	async getNetsolinObjbusqueda(pobjeto:any,pcadbus:any,pfiltroadi:any): Promise<Observable<any>> {
		// console.log('getNetsolinObjbusqueda pobjeto:'+pobjeto+' pcadbus:'+pcadbus+' pfiltroadi: '+pfiltroadi);
        NetsolinApp.objenvrestsolcomobog.usuario = this.globalfb.user.id;
        NetsolinApp.objenvrestsolcomobog.psw = NetsolinApp.oapp.cuserpsw;
        NetsolinApp.objenvrestsolcomobog.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
        NetsolinApp.objenvrestsolcomobog.tokenfb = await this.oauth.getAuthToken();
        NetsolinApp.objenvrestsolcomobog.tabla = "GENERAL";
		NetsolinApp.objenvrestsolcomobog.aplica = 0;
		NetsolinApp.objenvrestsolcomobog.filtro = pcadbus;
		NetsolinApp.objenvrestsolcomobog.filtroadi = pfiltroadi;
		return this.http.post(NetsolinApp.urlNetsolin + "Ejeservi_rest.csvc?VRCod_obj="+pobjeto, NetsolinApp.objenvrestsolcomobog)
			.pipe(
			map((resul:any) => {
				// console.log('map getNetsolinObjbusqueda');
				//  console.log(resul);
				 var result0 = resul[0];
				//  console.log(result0);
				 //si hay error retorna lista de errores sino el registro solicitado
				 if (typeof (result0) == "undefined") {
					 return resul;
				 } else {
					 return resul;
				 }
			})
			);
	}
  //Carga configuracion del objeto
	getNetsolinObjConfig(cod_obj: string): Observable<any> {
		// console.log('getNetsolinObjbusqueda pobjeto:'+pobjeto+' pcadbus:'+pcadbus+' pfiltroadi: '+pfiltroadi);
		var pobjllama = { ...NetsolinApp.objenvrest};
        pobjllama.usuario = NetsolinApp.oapp.cuserid;
        pobjllama.psw = NetsolinApp.oapp.cuserpsw;
        pobjllama.prefijobd = NetsolinApp.oapp.prefijo_sqlbd;
		pobjllama.cod_objeto = cod_obj;
		      return this.http.post(NetsolinApp.urlNetsolin + "netsolin_servirestgo.csvc?VRCod_obj=RESTBUSOBJETO", pobjllama)
			.pipe(
			map((resul:any) => {
				// console.log('map getNetsolinObjbusqueda');
				//  console.log(resul);
				 var result0 = resul[0];
				//  console.log(result0);
				 //si hay error retorna lista de errores sino el registro solicitado
				 if (typeof (result0) == "undefined") {
					 return resul;
				 } else {
					 return resul;
				 }
			})
			);
	}
  async gettokenFb(){
    NetsolinApp.objenvrest.tokenfb = await this.oauth.getAuthToken();
    this.ult_tokenfb = NetsolinApp.objenvrest.tokenfb;
  }

	//Ejecuta servicio rest en Netsolin con un objeto pparam que lleva parametros
	//retorna errores o cursor con resultado
	//Ejemplo de uso para retornar precio d eventa objeto: RESTCONLISTPREC
	///con parametro de llamado: "parametros":{"lista": "V01","cod_refven": "100    ","cod_tercer": "",
	///            "proc_ven": "016 ", "cantidad":10 }
  async	getNetsolinObjconParametros(pobjeto:any,pparam:any):  Promise<Observable<any>> {
		// console.log('getNetsolinObjconParametros pobjeto:'+pobjeto);
		var pobjllama = { ...NetsolinApp.objenvrest};

    pobjllama.usuario = this.globalfb.user.id;
        pobjllama.psw = NetsolinApp.oapp.cuserpsw;
        pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
        pobjllama.tokenfb = await this.oauth.getAuthToken();
        this.ult_tokenfb = pobjllama.tokenfb;
		    pobjllama.filtro = "";
		    pobjllama.parametros = pparam;
		if (pobjllama.tiporet != "OBJ")
			pobjllama.tiporet= "CON";
      return this.http.post(NetsolinApp.urlNetsolin + "Ejeservi_rest.csvc?VRCod_obj="+pobjeto, pobjllama)
			.pipe(
			map((resul:any) => {
				// console.log('map getNetsolinObjconParametros');
				//  console.log(resul);
				 var result0 = resul[0];
				//  console.log(result0);
				 //si hay error retorna lista de errores sino el registro solicitado
				 if (typeof (result0) == "undefined") {
					 return resul;
				 } else {
					 return resul;
				 }
			})
			);
	}
	//Ejecuta servicio rest en Netsolin con un objeto pparam que lleva parametros
	//retorna errores o cursor con resultado
	//Ejemplo de uso para retornar precio d eventa objeto: RESTCONLISTPREC
	///con parametro de llamado: "parametros":{"lista": "V01","cod_refven": "100    ","cod_tercer": "",
	///            "proc_ven": "016 ", "cantidad":10 }
  async	getNetsolinObjconParametrosEjeobj(pobjeto:any,pparam:any):  Promise<Observable<any>> {
		// console.log('getNetsolinObjconParametros pobjeto:'+pobjeto);
		var pobjllama = { ...NetsolinApp.objenvrest};

    pobjllama.usuario = this.globalfb.user.id;
        pobjllama.psw = NetsolinApp.oapp.cuserpsw;
        pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
        pobjllama.tokenfb = await this.oauth.getAuthToken();
		    pobjllama.filtro = "";
		    pobjllama.parametros = pparam;
		if (pobjllama.tiporet != "OBJ")
			pobjllama.tiporet= "CON";
      return this.http.post(NetsolinApp.urlNetsolin + "Ejeservi_rest.csvc?VRCod_obj="+pobjeto, pobjllama)
      // return this.http.post(NetsolinApp.urlNetsolin + "EjeConsultahtmlrest.csvc?VRCod_obj="+pobjeto, pobjllama)
			.pipe(
			map((resul:any) => {
				// console.log('map getNetsolinObjconParametros');
				//  console.log(resul);
				 var result0 = resul[0];
				//  console.log(result0);
				 //si hay error retorna lista de errores sino el registro solicitado
				 if (typeof (result0) == "undefined") {
					 return resul;
				 } else {
					 return resul;
				 }
			})
			);
	}
//igual al anterior pero retorna objeto
async getNetsolinObjconParametrosretobj(pobjeto:any,pparam:any): Promise<Observable<any>> {
  // console.log('getNetsolinObjconParametros pobjeto:'+pobjeto);
    var pobjllama = { ...NetsolinApp.objenvrest};
     pobjllama.usuario = this.globalfb.user.id;
      pobjllama.psw = NetsolinApp.oapp.cuserpsw;
      pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
      pobjllama.tokenfb = await this.oauth.getAuthToken();

  // pobjllama.usuario = 'NETSOLIN';
      // pobjllama.psw = '818B9B5D757885A18D8B908B8D9C989594A397AB9DA0AC9B9DD3CAD0D7C9CCA6CAD7D5D9D8CED6CFAFDFE1E4D4D88DA0A186' ;
      // pobjllama.prefijobd = 'SITC';
        pobjllama.filtro = "";
        pobjllama.parametros = pparam;
      //OP FEB 2 22 INCLUIR PARA QUE FUNCIONE EN PROD
      // pobjllama.en_prod ='PROD';
  if (pobjllama.tiporet != "OBJ")
    pobjllama.tiporet= "CON";
    // console.log(NetsolinApp.urlNetsolin + "netsolin_servirestgo.csvc?VRCod_obj="+pobjeto, pobjllama, JSON.stringify(pobjllama));
      //   return this.http.post(NetsolinApp.urlNetsolin + "netsolin_servirestgo.csvc?VRCod_obj="+pobjeto, pobjllama)
    //OP FEB 11 22 QUEDA con  netsolin_servirestgo para que retorne objeto
    console.log(NetsolinApp.urlNetsolin + "netsolin_servirestgo.csvc?VRCod_obj="+pobjeto, pobjllama, JSON.stringify(pobjllama));
        return this.http.post(NetsolinApp.urlNetsolin + "netsolin_servirestgo.csvc?VRCod_obj="+pobjeto, pobjllama)
    .pipe(
    map((resul:any) => {
      // console.log('map getNetsolinObjconParametros');
      //  console.log(resul);
       var result0 = resul[0];
      //  var result0 = resul[0].resultado;
      //  console.log(result0);
       //si hay error retorna lista de errores sino el registro solicitado
       if (typeof (result0) == "undefined") {
         return resul;
       } else {
         return resul;
       }
    })
    );
}


//Ejecuta servicio rest en Netsolin con un Link
//retorna errores o cursor con resultado
getNetsolinObjconLink(plink: string):  Observable<any> {
  var pobjllama = { ...NetsolinApp.objenvrest};
  // console.log('getNetsolinObjconLink plink:'+plink);
  pobjllama.usuario = this.globalfb.user.id;
  pobjllama.psw = NetsolinApp.oapp.cuserpsw;
  pobjllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
  // pobjllama.tokenfb = await this.oauth.getAuthToken();
  pobjllama.tokenfb = this.ult_tokenfb;
      pobjllama.filtro = "";
  pobjllama.tiporet= "CON";
      //   pobjllama.parametros = pparam;
  //OP FEB 2 22 INCLUIR PARA QUE FUNCIONE EN PROD
   pobjllama.en_prod ='PROD';
  if (pobjllama.tiporet != "OBJ")
    pobjllama.tiporet= "CON";
    // console.log(NetsolinApp.urlNetsolin + "netsolin_servirestgo.csvc?VRCod_obj="+pobjeto, pobjllama, JSON.stringify(pobjllama));
      //   return this.http.post(NetsolinApp.urlNetsolin + "netsolin_servirestgo.csvc?VRCod_obj="+pobjeto, pobjllama)
    //OP FEB 2 22 QUEDA EN PRUEBA LLAMADO Ejeservi_rest EN CAMBIO DE netsolin_servirestgo ya que este ultimo no retorna cursor solo como lo requiere mostrar html
    // console.log(NetsolinApp.urlNetsolin + plink, pobjllama, JSON.stringify(pobjllama));
        return this.http.post(NetsolinApp.urlNetsolin + plink, pobjllama)
    .pipe(
    map(resul => {
      // console.log('map getNetsolinObjconLink');
      //  console.log(resul);
       var result0 = resul;
      //  var result0 = resul[0].resultado;
      //  console.log(result0);
       //si hay error retorna lista de errores sino el registro solicitado
       if (typeof (result0) == "undefined") {
         return resul;
       } else {
         return resul;
       }
    })
    );
}

async pushNotification(title: string, mensaje: string, ptodos:boolean, pidusuar:any) {
  // console.log('pushNotification pidusuar ',pidusuar);
  const cheaders = {
    "Content-type": "application/json",
    "Authorization": "Basic Mzg2ZWFmMTYtZTM4Zi00MGFmLWEyMDUtNjA0YWI3ZWUwN2Uz",
  }
  let body='';
  if (ptodos) {
    body = JSON.stringify({
    "app_id" : "27ae219e-b05b-4a5a-b4e3-bca1a8651f86",
    "subtitle": {title: title},
    "contents": {"en": mensaje,"es": mensaje} ,
    "included_segments" : ["All"]
  });
} else {
    body = JSON.stringify({
    "app_id" : "27ae219e-b05b-4a5a-b4e3-bca1a8651f86",
    "subtitle": {title: title},
    "contents": {"en": mensaje,"es": mensaje} ,
    "include_player_ids": [pidusuar]
  });
}

  // console.log('pushNotification 2',body,cheaders);
  // this.http.post(url, NetsolinApp.objenvrest)
 this.http.post("https://onesignal.com/api/v1/notifications",body,{headers: cheaders})
 .subscribe((data: any) => {
  // console.log('pushNotification 3 data',data);
 });
//  console.log('pushNotification 4 ');


  // return this.http.post("https://onesignal.com/api/v1/notifications",body,{headers: cheaders})
  // .pipe(
  // map(resul => {
  // 	 console.log('Result onesignal',resul);
  // 	return resul[0];
  // })
  // );
}

cadafechadnetsolin(cfecha:any){
	let ano = cfecha.slice(0,4);
	let mes = cfecha.slice(5,7);
	let dia = cfecha.slice(8,10);

	let dfecha = new Date(ano,mes-1,dia,0,0,0);
	return dfecha;
  }

//cadena formato AAAAMMDD A FECHA TIEMPO 0
cadafecha(cfecha:string){
let ano : string = cfecha.slice(0,4);
let mes  : string = cfecha.slice(4,6);
let dia  : string = cfecha.slice(6,8);

let dfecha = new Date(parseInt(ano),parseInt(mes)-1,parseInt(dia),0,0,0);
return dfecha;
}

//recibe hora militar como numero y retorna cadena formato HH:MM AM/PM
cadhoramil(nhora:number){
let ch = nhora.toString();
let chh = '';
let cmm = '';
let campm = '';
let nnh = 0;
if (nhora < 1000) {
  chh = ch.slice(0,1);
  cmm = ch.slice(1,3);
} else {
  chh = ch.slice(0,2);
  cmm = ch.slice(2,4);
}
if(nhora < 1200){
  campm = 'AM';
} else {
  nnh = parseInt(chh) - 12;
  chh = nnh.toString();
  campm = 'PM';
}

return chh+':'+cmm+' '+campm;
}
//fecha a string para monitor en netsolin dd/mm/aa
fechacad(fechaf:string){
// console.log(fechaf);
// console.log(typeof(fechaf);
// console.log(fechaf.toDate());
// const fecha= fechaf.toDate();
// console.log(fecha);
// const dia = fecha.getDate();
// const mes = fecha.getMonth() + 1;
// const ano = fecha.getFullYear();

const cfecha = fechaf.substring(8,10) + '/' + fechaf.substring(5,7) + '/' + fechaf.substring(0,4);
// console.log(cfecha);
return cfecha;
}

getregTablaNetsolin(
  id: any,
  ptabla: string,
  paplica: string,
  pcampollave: string,
  pclase_nbs: string,
  pclase_val: string,
  pcamponombre: string
): Observable<any> {
  var objllama = { ...NetsolinApp.objenvrestcrud};

  // console.log("getregTabla");
  // console.log(id);
  // NetsolinApp.urlNetsolin = localStorage.getItem("urlNetsolin");
  objllama.usuario = this.globalfb.user.id;
  objllama.psw = NetsolinApp.oapp.cuserpsw;
  objllama.prefijobd = this.globalfb.empresa.parNetsolin.prefijoemprenetsolin;
  objllama.tokenfb = this.ult_tokenfb;
  objllama.tabla = ptabla;
  objllama.orden = "";
  objllama.aplica = parseInt(paplica);
  objllama.campos = "*";
  objllama.campollave = pcampollave;
  objllama.clase_val = pclase_val;
  objllama.clase_nbs = pclase_nbs;
  // console.log("Objeto Netsolin App->",objllama);
  // console.log('getregTabla pcampollave:'+pcampollave);
  if (typeof id == "string") {
    var acllave = pcampollave.split(",");
    var aid = id.split("|");
    // console.log(acllave);
    //solo tener encuenta 2 para armar condicion
    var lstrvalcampollave = "";
    if (acllave.length > 1) {
      var condi = "";
      condi =
        acllave[0] +
        "='" +
        aid[0] +
        "' AND " +
        acllave[1] +
        "='" +
        aid[1] +
        "'";
      objllama.llave = condi;
    } else {
      objllama.llave = id;
    }
  } else {
    objllama.llave = id;
  }
  // console.log("objllama.llave: "+objllama.llave);
  objllama.cursor = "Tcursorx";
  objllama.filtro = "";
  objllama.datos = id;
  // console.log("Dir Servicio->",NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc",objllama);
  return this.http
    .post(NetsolinApp.urlNetsolin + "nets_v_exi_ref.csvc",objllama)
    .pipe(
      map((resul:any) => {
        //  console.log('getregtabla resul');
        //  console.log(resul);
        var result0 = resul[0];
        // console.log(result0);
        //si hay error retorna lista de errores sino el registro solicitado
        if (typeof result0 == "undefined") {
          return resul;
        } else {
          return resul[0];
        }
        // return resul;
      })
    );
}

//OP mayo 19 22 CARGA tbase crm sectorcrm,campanas,origclipot
cargaTbaseDocSoporte(){
  this.cargo_tbasedocsopor = false;
  console.log('cargando tbase crm netsolin');
  this.getNetsolinObjconParametrosretobj('CARGATBASEDSOPOR',NetsolinApp.objenvrestsolcomobog).then(sub=> sub
  .subscribe((result:any) => {
      //viene registro con datos de la grafica
      // console.log("handleOpcionChange eje getNetsoli0nObjconParametrosretobj retorna result");
      // console.log(result);
      this.anosini=result.anosini;
      this.docsoporte=result.docsoporte;
      this.docsoporteaj = result.docsoporteaj;
      this.cen_costos=result.cen_costos;
      this.centros = this.cen_costos.filter(o => o.subcentro === '').map(reg => ({ id: reg.centro,nombre:reg.nombre,text:reg.nombre}));
      // this.subcentros = this.cen_costos.filter(o => o.subcentro === '').map(reg => ({ id: reg.centro,nombre:reg.nombre,text:reg.nombre}));
      this.acumuladorestodos=result.acumuladores;
      this.coddinam=result.coddinam;
      this.for_pago=result.for_pago;
      this.amonedas=result.monedas;
      this.cargo_tbasedocsopor=true;
      // this.cargobasenetsolin=true;
      // console.log(result0);
      if (typeof result.isCallbackError === "undefined") {
        //viene el registro con datos para el grafico
        console.log('carga tablas bas doc soporte ',result);
      } else {
        //viene el registro con el error
        console.error('Error en getNetsolinObjconParametrosretobj CARGATBASEDSOPOR result:',result);
      }
    },
    (error:any) => {
      console.log("Error en getNetsolinObjconParametros error otro tipo");
      console.log(error);
    }
  ));
}


}
